export default {
  translation: {
    commonUsedWords: {
      login: 'Giriş Yap',
      email: 'E-posta Adresi',
      password: 'Parola',
      emailIsRequired: 'E-posta gerekli',
      mustBeAValidEmail: 'Geçerli bir e-posta olmalı',
      deviceSerialNumber: 'Cihaz Seri Numarası',
      next: 'İleri',
      back: 'Geri',
      success: 'Başarılı',
      submit: 'Gönder',
      firstName: 'Ad',
      firstNameIsRequired: 'Ad gerekli',
      lastName: 'Soyad',
      lastNameIsRequired: 'Soyad gerekli',
      save: 'Kaydet',
      delete: 'Sil',
      undoChanges: 'Değişiklikleri Geri Al',
      cancel: 'İptal',
      loading: 'Yükleniyor...',
      yes: 'Evet',
      no: 'Hayır',
      clear: 'Temizle',
      confirm: 'Onayla',
      noOption: 'Seçenek yok',
      noCompressorTemplatesFound: 'Kompresör şablonu bulunamadı',
      openText: 'Aç',
      edit: 'Düzenle',
      logout: 'Çıkış Yap',
      update: 'Güncelle',
      locked: 'Kilitli',
      unlocked: 'Kilidi Açık',
      latitude: 'Enlem (LAT)',
      longitude: 'Boylam (LONG)',
      ok: 'Tamam',
      okay: 'Tamam',
      done: 'Bitti',
      comingSoon: 'Yolda...',
      reset: 'Sıfırla',
      attention: 'Dikkat',
      note: 'Not',
      continue: 'Devam Et',
      finish: 'Bitir',
      required: 'Bu alan zorunludur',
      close: 'Kapat',
      copiedToClipboard: 'Panoya kopyalandı',
      apply: 'Uygula',
    },
    api: {
      auth: {
        fieldsAreMissing: 'Zorunlu alanlar eksik',
        userNotFound: 'Kullanıcı bulunamadı',
        missingRefreshToken: 'Yenileme jetonu eksik',
        cannotRefreshToken: 'Jeton yenilenemiyor',
      },
      helpers: {
        error: 'Hata',
        invalidHTTPMethod: 'Geçersiz HTTP yöntemi',
      },
    },
    components: {
      autocompleteField: {
        presets: 'Önceden Ayarlanmış',
        results: 'Sonuçlar',
      },
      dateRangePicker: {
        changeDates: 'Tarihleri değiştir',
        selectDateRange: 'Bir tarih aralığı seçin',
        startDate: 'Başlangıç tarihi',
        endDate: 'Bitiş tarihi',
        datePresets: {
          label: 'Tarih ön ayarları',
          today: 'Bugün',
          yesterday: 'Dün',
          last7Days: 'Son 7 Gün',
          last30Days: 'Son 30 Gün',
          thisWeek: 'Bu Hafta',
          lastWeek: 'Geçen Hafta',
          thisMonth: 'Bu Ay',
          lastMonth: 'Geçen Ay',
          thisYear: 'Bu Yıl',
          lastYear: 'Geçen Yıl',
          allTime: 'Tüm zamanlar',
        },
        calendar: {
          weekDays: {
            mon: 'Pzt',
            tue: 'Sal',
            wed: 'Çar',
            thu: 'Per',
            fri: 'Cum',
            sat: 'Cmt',
            sun: 'Paz',
          },
          months: {
            january: 'Ocak',
            february: 'Şubat',
            march: 'Mart',
            april: 'Nisan',
            may: 'Mayıs',
            june: 'Haziran',
            july: 'Temmuz',
            august: 'Ağustos',
            september: 'Eylül',
            october: 'Ekim',
            november: 'Kasım',
            december: 'Aralık',
          },
        },
      },
      confirmEmail: {
        confirmEmail: 'E-posta Adresini Onayla',
        confirmEmailIsRequired: 'Onaylanmış e-posta adresi gereklidir',
        emailNotMatched: 'E-posta adresleri eşleşmiyor',
      },
      confirmPassword: {
        confirmPassword: 'Parolayı Onayla',
        confirmPasswordIsRequired: 'Onaylanmış parola gereklidir',
        newPasswordIsRequired: 'Yeni parola gereklidir',
        showPassword: 'Parolayı Göster',
        passwordLength: 'Parolalar en az 6 karakter olmalıdır',
        passwordContainSpaces: 'Parola boşluk içermemelidir',
        passwordNotMatch: 'Parola girişleri eşleşmiyor',
        newPassword: 'Yeni Parola',
      },
      confirmModal: {
        areYouSure: 'Emin misiniz?',
      },
      appliedFilters: {
        between: '{{firstValue}} ile {{secondValue}} arasında',
        bottom: 'Alt {{primaryValue}}%',
        top: 'Üst {{primaryValue}}%',
        activeFilters: 'Aktif Filtreler',
        active: 'aktif',
        closed: 'kapalı',
      },
      editTable: {
        editTable: 'Tabloyu Düzenle',
        selectDeselect: 'Tablo Değerlerini Seç / Seçimi Kaldır',
        resetToDefault: 'Varsayılana Sıfırla',
      },
      errorBoundary: {
        oops: 'Oops! Beklenmeyen bir şey oldu.',
        tryAgain: 'Lütfen tekrar deneyin! Sorun devam ederse lütfen yöneticinize başvurun.',
        refresh: 'Yenile',
      },
      noResultFound: {
        noResultFoundTryAgain: 'Üzgünüz, sonuç bulunamadı. Lütfen tekrar deneyin.',
      },
      permissionGuard: {
        invalidPermission: 'Geçersiz izin yapısı, dizide 3 öğe bekleniyor',
      },
      preview: {
        findInView: 'Görünümde Bul',
        showDetails: 'Ayrıntıları Göster',
        closeEsc: 'Kapat (Esc)',
        prevLeftArrow: 'Önceki (Sol ok)',
        nextRightArrow: 'Sonraki (Sağ ok)',
        proceedWithoutSaving: 'Kaydetmeden gezin',
        continueEditing: 'Düzenlemeye devam et',
        unsavedChanges: {
          partTwo: 'Kaydedilmemiş',
          partThree: 'DEĞİŞİKLİKLERİNİZ VAR.',
          partFour: 'Kaydetmeden gezinmek tüm değişiklikleri yok sayacaktır. Emin misiniz?',
        },
      },
      printRecord: {
        title: 'Kayıt',
        date: 'Tarih:',
        location: 'Konum',
        leakDetails: 'Detaylar',
        leakParameters: 'Parametreler',
        energyLoss: 'Enerji Kaybı',
        leakSourceEquipment: 'Kayıp Kaynağı Ekipmanı',
        notes: 'Notlar',
        leakEventStatus: 'Durum',
        requiredAction: 'Gerekli Eylem',
        leakSourceImage: 'Kayıp Kaynağı Görseli',
        sourceImages: 'Kaynak resimleri',
        additionalImages: 'Ek görseller',
        additionalImage: 'Ek görsel',
        smartLeakTag: 'Akıllı Etiket',
        workRef: 'İş Referansı',
        lossPerYear: 'Kayıp ({{currency}}/yıl)',
        costOfEnergy: 'Enerji Maliyeti ({{currency}}/kWh)',
        eventRecordTitle: 'Olay Kaydı',
        recordedOn: '{{date}} tarihinde kaydedildi',
        eventParameters: 'Olay Parametreleri',
        eventMetrics: 'Olay Metrikleri',
        sourceEquipment: 'Kaynak Ekipmanı',
        eventStatus: 'Olay Durumu',
        sourceImageCaptures: 'Kaynak Görüntü Yakalamaları',
        fftNotAvailable: 'Bu kayıt için FFT verisi mevcut değil',
        imageNotAvailable: 'Görüntü mevcut değil',
        generatedOn: '{{date}} tarihinde oluşturuldu',
        pageOfTotal: 'Sayfa {{page}} / {{total}}',
        energyPerYear: 'Enerji (kWh/yıl)',
      },
      exportSectionsDialog: {
        title: 'Dışa aktarma bölümlerini seçin',
        exportingSingular: '1 kayıt dışa aktarılıyor.',
        exportingPlural: '{{count}} kayıt dışa aktarılıyor.',
        selectSectionsHint: "PDF'e dahil edilecek bölümleri seçin.",
        visualizationsHint: 'Görselleştirmeler ek render gerektirir ve büyük dışa aktarmalar için birkaç saniye daha sürebilir.',
        default: 'Varsayılan',
        selectAll: 'Tümünü seç',
        groups: {
          summary: 'Özet',
          clientLocation: 'Müşteri ve konum',
          recordDetails: 'Kayıt ayrıntıları',
          source: 'Kaynak',
          status: 'Durum',
          visualizations: 'Görselleştirmeler',
        },
        sections: {
          summary: 'Özet sayfası',
          clientInfo: 'Müşteri bilgileri',
          leakParameters: 'Olay parametreleri',
          energyLoss: 'Enerji kaybı / Elektrik parametreleri',
          leakMetrics: 'Olay metrikleri',
          sourceEquipment: 'Kaynak ekipmanı + görüntüler',
          leakStatus: 'Olay durumu',
          fft: 'FFT frekans spektrumu',
        },
      },
      assignedAction: {
        actionHeader: {
          deleteAssignmentSuccess: 'Atama silindi',
          deleteAssignmentError: 'Atama silinemiyor. Lütfen daha sonra tekrar deneyin',
          currentlyAssigned: 'Şu Anda Atanan Eylem',
          repairedBy: 'Onaran',
          text: 'Bu atamayı silmek üzeresiniz. Bu işlem geri alınamaz',
        },
        actionSaveDate: 'Son kaydedildi',
      },
      visibleColumnsPopper: {
        tableValues: 'Tablo Değerlerini Seç / Seçimi Kaldır',
      },
      tableHead: {
        deselectCurrentPage: 'Mevcut Sayfayı Seçimi Kaldır',
        selectCurrentPage: 'Mevcut Sayfayı Seç',
      },
      coverPage: {
        costDisclaimer: 'Not: Mali kayıp ve maliyet tasarrufları yalnızca basınçlı hava kaçağı kayıtlarıyla ilişkilidir.',
        title: 'Kayıt Raporu',
        reportDate: 'Rapor Tarihi: {{date}}',
        poweredBy: '{{companyName}}<reg>®</reg> tarafından sağlanmaktadır',
        date: 'Tarih Aralığı: {{from}} - {{to}}',
        includedRecords: 'Dahil Edilen Kayıtlar: {{count}}',
        totalLoss: 'Toplam Kayıp',
        lossByCurrency: '{{currency}}: {{loss}}',
        totalKwhLoss: 'Toplam kWh Kaybı: {{kwh}} kWh/yıl',
      },
      tagsCoverPage: {
        title: 'Akıllı Etiketler Raporu',
        reportDate: 'Rapor Tarihi: {{date}}',
        poweredBy: '{{companyName}}<reg>®</reg> tarafından sağlanmaktadır',
        date: 'Tarih Aralığı: {{from}} - {{to}}',
        includedTags: 'Dahil Edilen Akıllı Etiketler: {{count}}',
        includedRecords: 'Dahil Edilen Kayıtlar: {{count}}',
        totalKwhLoss: 'Toplam kWh Kaybı: {{kwh}} kWh/yıl',
      },
      EnergyEfficiencyGauge: {
        title: 'Enerji verimliliği değerlendirmesi',
        recommendedRange: 'Önerilen verimlilik aralığı',
        levels: {
          good: {
            label: 'İyi',
            description:
              'Sisteminiz ideal, en verimli potansiyeline yakın çalışıyor. Modern, yüksek verimli kompresör (ör. değişken hızlı sürücü veya tasarım noktasında tam yüklü döner vidalı kompresör)',
          },
          average: {
            label: 'Orta',
            description:
              'Sisteminizde tipik verimsizlikler var; iyileştirme için alan bulunuyor. Tipik bir endüstriyel sistem olup muhtemelen daha eski ekipmanlara sahip veya büyük ölçüde daha az verimli kumandalarla (ör. yük/boşta) kısmi yükte çalışıyor',
          },
          poor: {
            label: 'Zayıf',
            description:
              'Sisteminiz oldukça verimsizdir (muhtemelen kaçaklar, eski ekipman veya yüksek elektrik maliyetleri nedeniyle) ve derhal müdahale gerektirir. Eski, bakımı zayıf bir sistem ya da birden fazla kompresörün optimize edilmeden aşırı kısmi yükte çalıştırıldığı durum',
          },
        },
      },
    },
    constants: {
      qualifiers: {
        EQUAL_TO: 'Eşittir',
        LESS_THAN: 'Küçüktür',
        GREATER_THAN: 'Büyüktür',
        LESS_THAN_OR_EQUAL_TO: 'Küçük veya eşittir',
        GREATER_THAN_OR_EQUAL_TO: 'Büyük veya eşittir',
        BETWEEN_A_AND_Y: 'Arasında',
        TOP_PERCENT: 'En üst "x"%',
        BOTTOM_PERCENT: 'En alt "x"%',
      },
      recordFields: {
        CREATED_AT: 'Oluşturulma Tarihi',
        RECORD_ID: 'Kayıt ID Numarası',
        DOCUMENT_ID: 'Kayıt ID Numarası',
        DOLLARS_PER_YEAR: 'Kayıp',
        GAS_COMPONENT: 'Gaz/Komponent',
        LEAK_TYPE: 'Tip Profili',
        DATE_TIME: 'Oluşturulma Tarihi/Zamanı',
        DB_PEAK: 'DB Zirve',
        COMPANY: 'Firma',
        NOTES: 'Notlar',
        USER: 'Kullanıcı',
        EQUIPMENT_TAG: 'Ekipman/Komponent Etiketi',
        FLOW: 'Akış (m³/h)',
        EQUIPMENT: 'Birim/Bina/Makine',
        ROUTE: 'Rota',
        ROUTE_LOCATION: 'Rota Konumu',
        ROUTE_EQUIPMENT_NAME: 'Rota Ekipmanı',
        PROJECT_SURVEY: 'Denetim/Anket Kaydı',
        OUTAGE_STATUS: 'Kesinti/İşlemler Gerekiyor mu?',
        FACILITY: 'Tesis/Site',
        ACTION_STATUS: 'Eylem Durumu',
        SERVICE_TYPE: 'Servis/Tipi',
        DB_ACTIVE: 'dB Aktif',
        REFERENCE_ID: 'Proje #/Anket ID',
        AMBIENT_TEMPERATURE: 'Çevre Sıcaklığı (°C)',
        LEAK_PRESSURE: 'Basınç (kPag)',
        LEAK_TEMPERATURE: 'Gaz Sıcaklığı (°C)',
        LEAK_CATEGORY: 'Kategori',
        DISTANCE: 'Mesafe (m)',
        GAS_COST: 'Gaz Maliyeti ($/m³)',
        COMPRESSOR_FLOW: 'm³/h başına BHP',
        DEVICE_ID: 'Cihaz ID',
        COMPRESSOR_BHP: 'Kompresör BHP',
        COMPRESSOR_TYPE: 'Kompresör Tipi',
        MOTOR_EFFICIENCY: 'Motor Verimliliği (%)',
        ENERGY_COST: 'Enerji Maliyeti ($/kWh)',
        HOURS: 'Yıllık Çalışma Saatleri',
        LOCATION: 'Konum',
        LAST_MODIFIED: 'Son Kaydedilen Tarih/Saat',
        POWER_LOAD: '% Tam Yük Gücü',
        CLIENT: 'Müşteri',
        SERVICE: 'Servis',
        CAPACITY: '% Kapasite',
        EQUIPMENT_TYPE: 'Ekipman/Komponent Tipi',
        SMART_TAG: 'Akıllı Etiket No',
        WORK_REF: 'İş Referans No',
        REPAIRED_BY: 'Tamir Edilen',
        ALTITUDE: 'Rakım (m)',
        REQUIRED_ACTION: 'Gerekli Eylem',
        FREQUENCY_LOW_BOUND: 'Frekans (Düşük)',
        FREQUENCY_HIGH_BOUND: 'Frekans (Yüksek)',
        SENSITIVITY: 'Duyarlılık',
        KWH_PER_YEAR: 'kWh/yıl',
        ASSIGNED_BY: 'Atayan',
        ASSIGNED_TO: 'Atanan',
        ASSIGNED_DATE: 'Atanma Tarihi',
        LOSS_PER_YEAR: 'Kayıp (yıllık)',
        ASSIGNED: 'Atandı',
        CREATOR_USER_ID: 'Kullanıcı ID',
        CURRENCY: 'Para Birimi',
        COMPLETED_ON: 'Tamamlanma Tarihi',
        IMAGES: 'Kaynak Resimler',
        ACTION_STATUS_MODIFIED: 'Eylem Durumu Değiştirildi',
        TYPE: 'Tip',
      },
      electricalRecordFields: {
        REGION: 'Bölge',
        LOCATION_TYPE: 'Yer Türü',
        VOLTAGE: 'Gerilim',
        PHASE: 'Faz',
        FREQUENCY: 'Frekans',
        ELECTRICAL_EQUIPMENT_TAG: 'Cihaz/Parça',
        ELECTRICAL_EQUIPMENT_TYPE: 'Cihaz/Parça Türü',
        FAULT_TYPE: 'Arıza Türü',
        ELECTRICAL_NOTES: 'Notlar',
      },
      IMPERIAL_LABELS: {
        FLOW: 'Akış (cfm)',
        AMBIENT_TEMPERATURE: 'Ortam Sıcaklığı (°F)',
        LEAK_PRESSURE: 'Basınç (psi)',
        LEAK_TEMPERATURE: 'Gaz Sıcaklığı (°F)',
        DISTANCE: 'Mesafe (ft)',
        GAS_COST: 'Gaz Maliyeti ($/ft³)',
        COMPRESSOR_FLOW: 'BHP başına cfm',
        ALTITUDE: 'Rakım (ft)',
      },
      METRIC_EU_LABELS: {
        FLOW: 'Akış (m³/min)',
        LEAK_PRESSURE: 'Basınç (bar)',
        COMPRESSOR_FLOW: 'm³/min başına BHP',
      },
      userFields: {
        EMAIL: 'E-posta',
        ROLE: 'Rol',
        DEVICE_ID: 'Cihaz Kimliği',
        SUBSCRIPTION_RENEWAL_DATE: 'Abonelik Yenileme Tarihi',
        DATE_TIME: 'Oluşturuldu',
        ACTIVE: 'Durum',
        SOFTWARE_VERSION: 'Yazılım Sürümü',
        FIRMWARE_VERSION: 'Donanım Yazılımı Sürümü',
        FIRST_NAME: 'Ad',
        LAST_NAME: 'Soyad',
        COMPANY_SLUG: 'Şirket',
        COMPANY_NAME: 'Şirket',
      },
      auditFields: {
        documentId: 'Kayıt Kimlik Numarası',
        companyName: 'Şirket Adı',
        auditorName: 'Denetçi Adı',
        auditorEmail: 'Denetçi E-postası',
        createdAt: 'Oluşturulma Tarihi',
        updatedAt: 'Güncellenme Tarihi',
        comment: 'Yorumlar',
        isLocked: 'Denetim Kilidi',
      },
      deviceFields: {
        DEVICE_ID: 'Cihaz Kimliği',
        ACTIVE: 'Durum',
        REGISTERED_ON: 'Etkinleştirildiği Tarih',
        EVENT_COUNT: 'Kayıtlar',
        UNIQUE_COMPANIES: 'Şirketler',
        LAST_USED_AT: 'Son Kullanım Tarihi',
        LAST_USED_BY_NAME: 'Son Kullanılan İsim',
        LAST_USED_BY_EMAIL: 'Son Kullanılan E-posta',
        LOCATION: 'Son Kullanılan Konum',
        FIRMWARE_VERSION: 'Donanım Yazılımı Sürümü',
      },
      enpisFields: {
        labels: {
          NO_OF_LEAKS_FOUND: 'Bulunan Kaçak Sayısı',
          NO_OF_LEAKS_REPAIRED: 'Onarılan Kaçak Sayısı',
          PERCENT_LEAKS_REPAIRED: '% Onarılan Kaçak',
          VOL_FLOW_FOUND: 'Bulunan Hacim Akışı',
          VOL_FLOW_REPAIRED: 'Onarılan Hacim Akışı',
          PERCENT_VOL_FLOW_REPAIRED: '% Onarılan Hacim Akışı',
          VALUE_FOUND: 'Bulunan Değer',
          VALUE_REPAIRED: 'Onarılan Değer',
          ENERGY_SAVING_OPPORTUNITY_FOUND: 'Enerji tasarrufu fırsatı (Bulunan)',
          ENERGY_SAVING_OPPORTUNITY_PERCENT: 'Enerji tasarrufu fırsatı % (Bulunan vs hesaplanan veya ölçülen)',
          ENERGY_SAVING_REALIZED_FIXED: 'Gerçekleşen Enerji Tasarrufu (Onarılan)',
          ENERGY_SAVING_REALIZED_PERCENT: 'Gerçekleşen Enerji Tasarrufu % (Onarılan vs hesaplanan veya ölçülen)',
          SYSTEM_CONTROL_PRESSURE_REDUCED: 'Sistem kontrol basıncı azaltıldı',
        },
        labelsImperial: {
          VOL_FLOW_FOUND: 'Bulunan Hacim Akışı (cfm)',
          VOL_FLOW_REPAIRED: 'Onarılan Hacim Akışı (cfm)',
          ENERGY_SAVING_OPPORTUNITY_FOUND: 'Enerji Tasarrufu Fırsatı (Bulunan) (BTU)',
          ENERGY_SAVING_REALIZED_FIXED: 'Gerçekleşen Enerji Tasarrufu (Onarılan) (BTU)',
          SYSTEM_CONTROL_PRESSURE_REDUCED: 'Sistem Kontrol Basıncı Azaltıldı (psi)',
        },
        labelsMetricEu: {
          VOL_FLOW_FOUND: 'Bulunan Hacim Akışı (m³/min)',
          VOL_FLOW_REPAIRED: 'Onarılan Hacim Akışı (m³/min)',
          SYSTEM_CONTROL_PRESSURE_REDUCED: 'Sistem kontrol basıncı azaltıldı (bar)',
        },
        columns: {
          PERFORMANCE_INDICATOR: 'Performans Göstergesi',
          ENPI_VALUE: 'EnPI Değeri',
          ENB_VALUE: 'EnB Değeri',
          SUCCESS_THRESHOLD: 'Başarı Eşiği (%)',
        },
      },
      companiesFields: {
        labels: {
          NAME: 'Şirket Adı',
          COUNTRY_ID: 'Ülke',
          CURRENCY: 'Para Birimi',
          LANGUAGE: 'Dil',
          INDUSTRY: 'Endüstri',
        },
      },
      assignedAction: {
        assignedTo: 'Atanan Kişi',
        assignedBy: 'Atayan Kişi',
        assignedDate: 'Atama Tarihi',
        requestReassign: 'Yeniden Atama Talep Et',
        actionStatus: 'Eylem Durumu',
        partsNeeded: 'Gerekli Parça',
        productionOutage: 'Kapatma Talep Edildi',
        timeToRepair: 'Onarım Süresi',
        repairCost: 'Onarım Maliyeti',
        closeOutRef: 'Kapanış Referansı',
        'assignmentRecord.documentId': 'Kayıt Kimliği',
        assignmentId: 'Atama Kimliği',
        owner: 'Sahip',
        companyName: 'Şirket',
        assignmentActive: 'Atama Durumu',
        'assignmentRecord.leakStatus.building': 'Birim/Bina/Makine',
        'assignmentRecord.leakStatus.facility': 'Tesis',
        'assignmentRecord.leakStatus.routeName': 'Rota',
        'assignmentRecord.leakStatus.smartTag': 'Akıllı Etiket #',
        'assignmentRecord.leakStatus.workRef': 'İş Referansı #',
        'assignmentRecord.currency': 'Para Birimi',
      },
      AAR_FIELD_LABEL: {
        NOTES: 'Alınan Eylem',
        CLOSE_OUT_REF: 'Eylem Kapanış Referansı #',
        PARTS_NEEDED: 'Yeni parça/bileşen gerekli',
        PRODUCTION_OUTAGE: 'Üretim kesintiye uğradı',
        REPAIR_COST: 'Maliyet ($)',
        REQUEST_REASSIGN: 'Yeniden atama talep et',
        ACTION_STATUS: 'Eylem durumu',
        TIME_TO_REPAIR: 'Onarım için geçen süre (dakika)',
      },
      leak: {
        chartsLabels: {
          FLOW_BY_LEAK: 'Kaçak kategorisine göre akış',
          LOSS_BY_LEAK: 'Kaçak kategorisine göre kayıp',
          TAGS_BY_LEAK: 'Kaçak kategorisine göre etiketler',
          AVG_FLOW_BY_LEAK: 'Kaçak kategorisine göre ortalama akış',
          SAVING_OPT_BY_REPAIR: 'Onarım süresine göre fırsat ve tasarruf',
          FLOW_REPAIR_TIME: 'Onarım süresine göre akış',
          LOSS_REPAIR_TIME: 'Onarım süresine göre kayıp',
          FLOW_REPAIR_PROG: 'Onarım ilerlemesine göre akış',
          TOTAL_REPAIR_PROG: 'Onarım ilerlemesine göre kayıp',
          FLOW_BY_EQUIP_COMP: 'Ekipman/bileşene göre akış',
          LOSS_BY_EQUIP_COMP: 'Ekipman/bileşene göre kayıp',
          TAGS_BY_EQUIP_COMP: 'Ekipman/bileşene göre etiketler',
        },
        leakCategoryLabels: {
          LOW: 'Düşük',
          MEDIUM: 'Orta',
          HIGH: 'Yüksek',
        },
        actionStatus: {
          OPEN: 'Açık',
          COMPLETE: 'Tamamlandı',
        },
        equipmentTypes: {
          CONNECTOR: 'Bağlantı Elemanı',
          CONTROL_VALVE: 'Kontrol Vanası',
          HOSE: 'Hortum',
          TUBE_FITTING: 'Boru Bağlantı Parçası',
          METER: 'Sayaç',
          OPEN_ENDED_LINE: 'Açık Uçlu Hat',
          PRESSURE_RELIEF_VALVE: 'Basınç Tahliye Vanası',
          PUMP_SEAL: 'Pompa Contası',
          REGULATOR: 'Regülatör',
          VALVE: 'Vana',
          LEVEL_CONTROLLER: 'Seviye Kontrol Cihazı',
          POSITIONER: 'Konumlandırıcı',
          PRESSURE_CONTROLLER: 'Basınç Kontrol Cihazı',
          TRANSDUCER: 'Dönüştürücü',
          GENERIC_PNEUMATIC_INSTRUMENT: 'Genel Pnömatik Enstrüman',
          GENERIC_RECIPROCATING_COMPRESSOR: 'Genel Pistonlu Kompresör',
          GENERIC_CENTRIFUGAL_COMPRESSOR: 'Genel Santrifüj Kompresör',
        },
        mainGasValues: {
          AIR: 'Hava',
          METHANE: 'Metan (CH4)',
          CARBON_DIOXIDE: 'Karbondioksit (CO2)',
          HYDROGEN: 'Hidrojen (H2)',
          HELIUM: 'Helyum (He)',
          NITROGEN: 'Azot (N2)',
          REFRIGERANT: 'Soğutucu (HFCs)',
          ARGON: 'Argon (Ar)',
          OXYGEN: 'Oksijen (O)',
          WATER: 'Su (Buha',
        },
        leakTypeValues: {
          DEFAULT: 'Hiçbiri seçilmedi',
          HOLE: 'Delik',
          CRACK: 'Çatlak',
          FITTING: 'Bağlantı Parçası',
          FLANGE: 'Flanş',
          'GLAND/SEAL': 'Conta/Mühür',
          THREAD: 'Vida Dişi',
          'TUBE/HOSE': 'Boru/Hortum',
        },
        serviceValues: {
          COMPRESSED_AIR: 'Basınçlı Hava',
          VACUUM: 'Vakum',
          STEAM: 'Buhar',
          PROCESS_GAS: 'Proses Gazı',
          LIQUID: 'Sıvı',
        },
        compressorTypesValues: {
          ROTARY_SCREW: 'Rotary Vidalı',
          RECIPROCATING: 'Pistonlu',
          SCROLL: 'Scroll',
          CENTRIFUGAL: 'Santrif',
        },
        regionValues: {
          NORTH_AMERICA: 'Kuzey Amerika',
          OUTSIDE_NORTH_AMERICA: 'Kuzey Amerika Dışı',
        },
        locationTypeValues: {
          RESIDENTIAL: 'Konut',
          COMMERCIAL: 'Ticari',
          INDUSTRIAL: 'Sanayi',
          MEDIUM_VOLTAGE: 'Orta Gerilim',
          HIGH_VOLTAGE: 'Yüksek Gerilim',
        },
        phaseValues: {
          SINGLE_PHASE: 'Tek faz',
          THREE_PHASE: 'Üç faz',
        },
        faultValues: {
          SELECT_FAULT_TYPE: 'Arıza Türü Seçin',
          KNICKS_OR_VOIDS_IN_INSULATION: 'Yalıtımda kesikler veya boşluklar',
          CORONA: 'Korona',
          TREEING: 'Ağaçlandırma',
          TRACKING: 'Takip',
          ARCING: 'Ark',
          'DIRTY_POWER/POWER_DISTORTION': 'Kirli güç/güç bozulması',
          MECHANICAL_LOOSENESS: 'Mekanik gevşeme',
          DELAMINATION_OF_WINDINGS: 'Sargı ayrılması',
          LOOSE_PANEL: 'Geç panel',
          VIBRATING_NAMEPLATE: 'Vibrasyon yapan plaka',
          ANTAGONISTIC_ULTRASOUND: 'Antagonistik ultrason',
          OTHER: 'Diğer',
        },
        electricEquipmentTypeValues: {
          MCC: 'MCC (Motor Kontrol Ekipmanı)',
          'TRANSFORMER,_DRY': 'Transformatör, Kuru',
          'TRANSFORMER,_OIL': 'Transformatör, Yağ',
          SWITCH_GEAR: 'Anahtar donanımı',
          PANEL: 'Panel',
          BUSDUCT: 'Anahtar hat',
          CABLE: 'Kablo',
          CONNECTOR: 'Bağlantı',
          BREAKER: 'Kesici',
          BUSHING: 'Yalıtıcı',
          TRANSMISSION_LINE: 'İletim hattı',
          'TRANSFORMER,_POLE': 'Transformatör, Direk',
          BATTERY: 'Akü',
          BATTERY_BANK: 'Akü bankası',
          TERMINALS: 'Terminaller',
          'TRANSFORMER,_STEP_UP': 'Transformatör, Yükseltici',
          'TRANSFORMER,_STEP_DOWN': 'Transformatör, Alçaltıcı',
          DISTRIBUTION_PANEL: 'Dağıtım paneli',
          BREAKER_PANEL: 'Kesici paneli',
          RELAYS: 'Röleler',
          CAPACITORS: 'Kondansatörler',
          REACTORS: 'Reaktörler',
          UPS: 'UPS',
          GROUNDING: 'Topraklama',
          POWER_METERS: 'Güç ölçerler',
          CURRENT_TRANSFORMERS: 'Akım transformatörleri',
          POTENTIAL_TRANSFORMERS: 'Potansiyel transformatörler',
          SURGE_PROTECTION: 'Aşırı gerilim koruması',
          CABLE_TRAYS: 'Kablo yolları',
          EMERGENCY_LIGHTING: 'Acil aydınlatma',
          CONTACTORS: 'Kontaklar',
          INVERTERS: 'Dönüştürücüler',
          SOLAR_PANELS: 'Güneş panelleri',
          BATTERY_STORAGE_SYSTEMS: 'Akü depolama sistemleri',
        },
        recordTypes: {
          leak: 'Sızıntı',
          electrical: 'Elektrik',
        },
        labels: {
          LOW: 'Düşük',
          MEDIUM: 'Orta',
          HIGH: 'Yüksek',
          EQUIPMENT: 'Ekipman',
          SAVINGS: 'Tasarruf',
          OPPORTUNITY: 'Fırsat',
          LOSS: 'Kayıp',
          REPAIRED: 'Onarıldı',
          UNREPAIRED: 'Onarılmadı',
          LESS_15_DAYS: '15 günden az',
          DAYS_16_TO_30: '16 ila 30 gün',
          DAYS_31_TO_60: '31 ila 60 gün',
          DAYS_61_TO_90: '60 günden fazla',
          LESS_THAN_15_DAYS: 'Onarıldı < 15 Gün',
          '16_TO_30_DAYS': 'Onarıldı 16-30 Gün',
          '31_TO_60_DAYS': 'Onarıldı 31-60 Gün',
          MORE_THAN_60_DAYS: 'Onarıldı 61-90 Gün',
          AIR: 'Hava',
          METHANE: 'Metan (CH4)',
          CARBON_DIOXIDE: 'Karbondioksit (CO2)',
          HYDROGEN: 'Hidrojen (H2)',
          HELIUM: 'Helyum (He)',
          NITROGEN: 'Azot (N2)',
          REFRIGERANT: 'Soğutucu (HFCs)',
          ARGON: 'Argon (Ar)',
          OXYGEN: 'Oksijen (O)',
          WATER: 'Su (Buha',
          DEFAULT: 'Hiçbiri seçilmedi',
          HOLE: 'Delik',
          CRACK: 'Çatlak',
          FITTING: 'Bağlantı Parçası',
          FLANGE: 'Flanş',
          'GLAND/SEAL': 'Conta/Mühür',
          THREAD: 'Vida Dişi',
          'TUBE/HOSE': 'Boru/Hortum',
          COMPRESSED_AIR: 'Basınçlı Hava',
          VACUUM: 'Vakum',
          STEAM: 'Buhar',
          PROCESS_GAS: 'Proses Gazı',
          LIQUID: 'Sıvı',
          ROTARY_SCREW: 'Rotary Vidalı',
          RECIPROCATING: 'Pistonlu',
          SCROLL: 'Scroll',
          CENTRIFUGAL: 'Santrif',
          CONNECTOR: 'Bağlantı Elemanı',
          CONTROL_VALVE: 'Kontrol Vanası',
          HOSE: 'Hortum',
          TUBE_FITTING: 'Boru Bağlantı Parçası',
          METER: 'Sayaç',
          OPEN_ENDED_LINE: 'Açık Uçlu Hat',
          PRESSURE_RELIEF_VALVE: 'Basınç Tahliye Vanası',
          PUMP_SEAL: 'Pompa Contası',
          REGULATOR: 'Regülatör',
          VALVE: 'Vana',
          LEVEL_CONTROLLER: 'Seviye Kontrol Cihazı',
          POSITIONER: 'Konumlandırıcı',
          PRESSURE_CONTROLLER: 'Basınç Kontrol Cihazı',
          TRANSDUCER: 'Dönüştürücü',
          GENERIC_PNEUMATIC_INSTRUMENT: 'Genel Pnömatik Enstrüman',
          GENERIC_RECIPROCATING_COMPRESSOR: 'Genel Pistonlu Kompresör',
          GENERIC_CENTRIFUGAL_COMPRESSOR: 'Genel Santrifüj Kompresör',
        },
        leakRecordPDF: 'Kayıtlar - {{date}}',
        leakTag: 'Akıllı Etiketler - {{date}}',
      },
      compressorFields: {
        labels: {
          COMPRESSOR_TAG: 'Kompresör Etiketi',
          COMPRESSOR_MAKE: 'Kompresör Markası',
          COMPRESSOR_MODEL: 'Kompresör Modeli',
          COMPRESSOR_TYPE: 'Kompresör Türü',
          NAMEPLATE_HP: 'Plaka Beygir Gücü (HP)',
          NAMEPLATE_CAPACITY: 'Plaka Kapasitesi',
          MOTOR_EFFICIENCY: 'Motor Verimliliği (%)',
          MOTOR_VOLTAGE: 'Motor Voltajı',
          FULL_LOAD_CURRENT: 'Tam Yük Akımı (Amper)',
          FULL_LOAD_INPUT_POWER: 'Tam Yük Giriş Gücü (kW)',
          RATED_PRESSURE: 'Anma Basıncı',
          PRESSURE_SETPOINT: 'Basınç Ayar Noktası',
          CONTROL: 'Kontrol',
          TOTAL_AIR_STORAGE_SIZE: 'Toplam Hava Depolama Boyutu',
          IS_ACTIVE: 'Kompresör Aktif / Kapalı',
          OPERATION_TYPE: 'Trim / Temel Yük',
          PERCENT_LOAD: '% Yük',
          COMPRESSOR_SETPOINT_SEU: 'Kompresör Ayar Noktası',
          COMPRESSOR_FLOW_SEU: 'Kompresör Akışı',
          SYSTEM_PRESSURE_SETPOINT: 'Sistem Basınç Ayar Noktası',
          SYSTEM_MEASURED_FLOW: 'Sistem Ölçülen Akış',
          DATE_TIME_RUNNING_STATE: 'Çalışma Durumu Tarih ve Saati',
          NOTES: 'Notlar',
          NAMEPLATE: 'Kompresör İsim Plakası',
          DATASHEET: 'Kompresör Veri Sayfası',
          BHP: 'BHP',
          OPERATING_HOURS: 'Çalışma Saatleri',
          LOADED_PERCENT_TIME_RUNNING: '% Çalışma Süresi',
          LOADED_PERCENT_FULL_LOAD_BHP: '% Tam Yük BHP (Kapasite)',
          UNLOADED_PERCENT_TIME_RUNNING: '% Çalışma Süresi',
          UNLOADED_PERCENT_FULL_LOAD_BHP: '% Tam Yük BHP (Kapasite)',
          ENERGY_COST: 'Toplam Elektrik Ücreti ($)',
          ANNUAL_ENERGY_COST: 'Yıllık Enerji Ücreti ($)',
          ANNUAL_ENERGY_KWH: 'Yıllık Enerji kWh',
          COST_FULLY_LOADED: 'Tam Yüklü Maliyet ($)',
          COST_UNLOADED: 'Boş Maliyet ($)',
          KWH_PER_YEAR_LOADED: 'Yüklü Yılda kWh',
          KWH_PER_YEAR_UNLOADED: 'Boş Yılda kWh',
          ENERGY_COST_PER_UNIT: '$/m³',
        },
        labelsImperial: {
          NAMEPLATE_CAPACITY: 'Plaka Kapasitesi (cfm)',
          FULL_LOAD_INPUT_POWER: 'Tam Yük Giriş Gücü (BTU/h)',
          RATED_PRESSURE: 'Anma Basıncı (psi)',
          PRESSURE_SETPOINT: 'Basınç Ayar Noktası (psi)',
          TOTAL_AIR_STORAGE_SIZE: 'Toplam Hava Depolama Boyutu (galon)',
          COMPRESSOR_SETPOINT_SEU: 'Kompresör Ayar Noktası (psi)',
          COMPRESSOR_FLOW_SEU: 'Kompresör Akışı (cfm)',
          SYSTEM_PRESSURE_SETPOINT: 'Sistem Basınç Ayar Noktası (psi)',
          SYSTEM_MEASURED_FLOW: 'Sistem Ölçülen Akış (cfm)',
          ENERGY_COST_PER_UNIT: '$/cf',
        },
        labelsMetricEu: {
          NAMEPLATE_CAPACITY: 'Plaka Kapasitesi (m³/min)',
          RATED_PRESSURE: 'Anma Basıncı (bar)',
          PRESSURE_SETPOINT: 'Basınç Ayar Noktası (bar)',
          COMPRESSOR_SETPOINT_SEU: 'Kompresör Ayar Noktası (bar)',
          COMPRESSOR_FLOW_SEU: 'Kompresör Akışı (m³/min)',
          SYSTEM_PRESSURE_SETPOINT: 'Sistem Basınç Ayar Noktası (bar)',
          SYSTEM_MEASURED_FLOW: 'Sistem Ölçülen Akış (m³/min)',
        },
      },
      energyFields: {
        labels: {
          UTILITY_PROVIDER: 'Kamu Hizmetleri Sağlayıcısı',
          ENERGY_COST: '$/kWh',
          ENERGY_UNIT: 'Birim',
          REBATE_COST: '$/kWh',
          REBATE_UNIT: 'Birim',
          ENERGY_SOURCES: 'Enerji Kaynakları',
          FE_HOURS_OPERATION: 'Çalışma Saatleri',
          FE_ENERGY_COST: 'Enerji Maliyeti ($/kWh)',
          FE_EFFICIENCY: 'Verimlilik (kW/m³/h)',
          KWH_PER_FLOW: 'kWh/m³/h',
          COST_PER_FLOW: '$/m³',
        },
        labelsImperial: {
          FE_EFFICIENCY: 'Verimlilik (kW/cfm)',
          KWH_PER_FLOW: 'kWh/cfm',
          COST_PER_FLOW: '$/cf',
        },
        labelsMetricEu: {
          FE_EFFICIENCY: 'Verimlilik (kW/m³/min)',
          KWH_PER_FLOW: 'kWh/m³/min',
        },
      },
    },
    hooks: {
      useError: {
        message: 'İstek doğrulama hatası. Lütfen form alanlarını kontrol edin.',
      },
    },
    layouts: {
      dashboardLayout: {
        topBar: {
          registerADevice: 'Cihaz Kaydet',
          help: 'Yardım',
          metric: 'Metrik',
          imperial: 'İmparatorluk',
          metricEu: 'Metric EU',
          downloadApk: 'APK İndir',
          downloadOta: 'Dosya İndir',
        },
        otaDialog: {
          title: 'Dosya İndir',
          downloadButton: 'İndir',
          serialNumberLabel: 'Cihaz Seri Numarası',
          serialNumberRequired: 'Seri numarası gerekli',
          fileDownloaded: '{{fileName}} dosyası başarıyla indirildi',
          errorFetchingFile: 'Dosya alınırken hata oluştu. Lütfen daha sonra tekrar deneyin',
          selectSerialNumber: 'Bir cihaz seri numarası seçin',
        },
        banners: {
          leakRecordsList: {
            dialogOne: 'Essential planındasınız.',
            dialogTwo: 'Buraya',
            dialogThree: 'tıklayın',
            dialogFour: 'yeni bir Yönetici lisansı satın almak için veya',
            dialogFive: 'support@prosaris.ca ile iletişime geçin.',
          },
          serviceUnavailable: 'Teknik zorluklar yaşıyoruz. Hizmetimiz etkilenebilir. Verdiğimiz rahatsızlıktan dolayı özür dileriz.',
          downForMaintenance: 'Bakım nedeniyle kapalıyız. Lütfen daha sonra tekrar deneyin.',
          tagsManagement: {
            question: 'PROSARIS Akıllı Etiketlerinden memnun musunuz?',
            purchaseLink: 'Ek akıllı etiketleri buradan satın alın!',
          },
        },
        mobileNav: {
          index: {
            menu: 'Menü',
            editProfile: 'Profili Düzenle',
            logout: 'Çıkış Yap',
          },
        },
        notifications: {
          title: 'Notifications',
          notificationsList: {
            clearAll: 'Tümünü Temizle',
            readAll: 'Tümünü Oku',
            noNotifications: 'Bildirim Yok',
          },
        },
        index: {
          dashboard: 'Kontrol Paneli',
          records: 'Kayıtlar',
          actions: 'Eylemler',
          company: 'Şirket',
          tags: 'Etiketl',
          support: 'Support',
        },
        loggedInAs: 'Giriş Yapıldı:',
      },
    },
    utils: {
      displayAssignedRecords: {
        cannontDeterminByField: 'Alan {{field}} ile etiketi belirleyemiyor',
        cannontDeterminByLabel: 'Etiket {{label}} ile alanı belirleyemiyor',
        active: 'Aktif',
        closed: 'Kapalı',
      },
    },
    views: {
      commonUsedWords: {
        dashboard: 'Kontrol Paneli',
        records: 'Kayıtlar',
        actions: 'Eylemler',
        company: 'Şirket',
        tags: 'Etiketler',
        redirecting: 'Yönlendiriliyorsunuz...',
      },
      account: {
        index: {
          updatePassword: 'Şifre başarıyla güncellendi.',
          accountDeletedSuccess: 'Hesap {{user}} başarıyla silindi',
          accountDeletedError: 'Hesap şu anda silinemiyor. Lütfen daha sonra tekrar deneyin.',
          authenticationError: 'Kullanıcı doğrulama başarısız oldu',
          currentPasswordIsRequired: 'Mevcut parola gerekli',
          firstNameIsRequired: 'Ad gerekli',
          lastNameIsRequired: 'Soyad gerekli',
          personalDetails: 'Temel Bilgiler',
          changePassword: 'Şifreyi sıfırla',
          currentPassword: 'Mevcut Şifre',
          profilePicture: 'Profil Resmi',
          dangerZone: 'Tehlike Bölgesi',
          integrations: 'Entegrasyonlar',
          sosShipments: 'SOS Envanteri',
          sosSyncMessage:
            'Bu işlem, Prosaris içinde SOS sipariş işlemeyi tetikler ve SOS Envanterinden en son verileri kullanır. Bu işlem genellikle 4 saatte bir otomatik olarak yönetilir, ancak bu düğmeyi kullanarak süreci manuel olarak başlatabilirsiniz.',
          sosSyncSuccess: 'SOS Senkronizasyonu başarıyla tetiklendi',
          triggerSosSync: 'SOS Senkronizasyonunu Başlat',
          hubspot: 'HubSpot',
          hubspotSyncMessage:
            "Bu süreç, platformun en son verilerini hemen HubSpot'a iletir. Bu senkronizasyon otomatik olarak her saat yapılır, ancak düğmeye tıklayarak senkronizasyonu gerektiğinde manuel olarak başlatabilirsiniz.",
          hubspotSyncSuccess: 'HubSpot Senkronizasyonu başarıyla tetiklendi',
          triggerHubspotSync: 'HubSpot Senkronizasyonunu Başlat',
          deleteAccountTitle: 'Hesabı Sil',
          deleteAccountMessage: 'Hesap artık kullanılamayacak ve tüm kişisel bilgiler kalıcı olarak silinecek.',
          alertTitle: 'Lütfen hesap silme işlemini onaylayın',
          deleteDialog: {
            dialogTwo: 'Hesabınızı silmek, tüm kişisel bilgilerinizin veritabanımızdan kalıcı olarak kaldırılmasına neden olacaktır.',
            dialogThree: 'BU İŞLEM GERİ ALINAMAZ.',
            dialogFour: 'Devam etmek için lütfen parolanızı girin.',
          },
        },
        toolBar: {
          cacheClearedSuccess: 'Önbellek başarıyla temizlendi!',
          editProfile: 'Profili Düzenle',
          clearCache: 'Önbelleği Temizle',
          alertTitle: 'Uygulama önbelleğini temizlemeyi onaylayın',
          deleteAll: 'Hepsini sil',
          accordionDialog: {
            dialogOne: 'Bu işlem, aşağıdaki sayfalar için kaydedilen tüm ayarları silecektir:',
            dialogTwo: 'Grafikler, Grafik Filtreleri, Zaman Aralığı',
            dialogThree: 'Filtreler, Sıralama, Sütunlar, Önizleme',
            dialogFour: 'Filtreler, Sütunlar',
            dialogFive: 'Seçilen şirket',
            dialogSix: 'Filtreler, Sütunlar',
          },
          deleteSelective: 'Seçerek Sil',
          selectiveDialog: 'Lütfen silmek istediğiniz kaydedilen ayarları seçin:',
        },
        constants: {
          Dashboard: {
            TIMEFRAME: 'Zaman Aralığı',
            CHART_FILTERS: 'Grafik Filtreleri',
            CHARTS: 'Grafikler',
          },
          Records: {
            HIGHLIGHTED: 'Önizleme',
            COLUMNS: 'Sütunlar',
            FILTERS: 'Filtreler',
            SORT_COLUMN: 'Sıralama',
          },
          Actions: {
            FILTERS: 'Filtreler',
            COLUMNS: 'Sütunlar',
          },
          Company: {
            SELECTED: 'Seçilen şirket',
          },
          Tags: {
            FILTERS: 'Filtreler',
            COLUMNS: 'Sütunlar',
          },
        },
      },
      assignmentsList: {
        filters: {
          companyName: 'Şirket',
          'leakStatus.building': 'Birim/Bina/Makine',
          'leakStatus.facility': 'Tesis',
          'leakStatus.smartTag': 'Akıllı Etiket #',
          'leakStatus.workRef': 'İş Referansı #',
        },
        tableBody: {
          noAssignmentsToDisplay: 'Görüntülenecek atama yok',
        },
        filtersCommonWords: {
          recordsFilter: 'Kayıt Filtresi',
          column: 'Sütun',
          selectAColumn: 'Bir sütun seçin...',
          addSearchTerm: 'Bir arama terimi ekleyin...',
          filtersArentAvailable: 'Filtreler mevcut değil',
          value: 'Değer',
          exportCSV: "CSV'yi Dışa Aktar",
          show: 'Göster',
          loadMoreRecords: 'Daha Fazla Kayıt Yükle',
          selectedAllRecords: 'Tüm kayıtlar seçildi ({{totalNum}})',
          selectedFromRecords: '{{totalNum}} kayıttan {{selectedNum}} kayıt seçildi',
          reset: 'Sıfırla',
        },
        invalidColumn: 'Geçersiz sütun {{column}}',
        assignedActionRecords: 'Atanmış Eylem Kayıtları',
      },
      auth: {
        forgotPasswordView: {
          forgotYourPassword: 'Şifrenizi mi unuttunuz?',
          successMessage: 'Onay e-postası gönderdik:',
        },
        authSuccess: {
          thanks: 'Teşekkürler!',
          backToLogin: 'Platforma giriş yap',
        },
        loginView: {
          forgotPass: 'Şifrenizi mi Unuttunuz?',
          createAccount: 'Hesap Oluştur',
          passwordIsRequired: 'Parola gerekli',
          resetPassword: 'Şifreyi sıfırla',
          contactSupport: 'Lütfen support@prosaris.ca ile iletişime geçin',
          incorrectEmailOrPassword: 'Yanlış e-posta veya parola',
          resetPassDialog: {
            dialogOne: 'Devam etmeden önce şifrenizi sıfırlamanız gerekiyor.',
            dialogTwo: 'Şifre sıfırlama talimatlarını içeren bir e-posta size gönderildi.',
          },
          ok: 'Tamam',
        },
        resetPasswordView: {
          passwordSuccessFullyReset: 'Şifreniz başarıyla sıfırlandı',
          enterNewPassword: 'Aşağıya yeni şifrenizi girin.',
          passwordChanged: 'Şifreniz değiştirildi.',
        },
        createCompanyView: {
          companyName: 'Şirket Adı',
          companyNameIsRequired: 'Şirket adı gerekli',
          successTitle: 'Tebrikler! {{companyName}} hesabınız başarıyla oluşturuldu.',
          successDescription:
            'Şirket hesabınız oluşturuldu. Platform üzerinden şirkete başka ekip üyeleri ekleyebilirsiniz. Ek sorularınız için {{companyEmail}} ile iletişime geçin.',
          companySetup: 'Şirket Kurulumu',
          createCompany: 'Yeni Şirket Oluştur',
          createCompanyDescription:
            '{{companyName}} platformuna yeniyseniz, şimdi platformda şirketinizi oluşturabilirsiniz. Şirket yöneticisi siz olacaksınız.',
          or: 'VEYA',
          joinExistingCompany: 'Mevcut Şirkete Katıl',
          joinExistingCompanyDescription:
            'Eğer organizasyonunuz {{companyName}} platformunda zaten bir şirket hesabına sahipse ve katılmak istiyorsanız, aşağıdaki iki seçenekten birini izleyin.',
          joinExistingCompanyOptions: {
            optionOne: '{{supportEmail}} üzerinden bizimle iletişime geçin. Bir ekip üyesi sizi istediğiniz şirkete ekleyecek.',
            optionTwo: 'Şirket yöneticisine ulaşın. Platform üzerinden size doğrudan bir davet gönderebilirler.',
          },
          essentialRoleMessage:
            '{{companyName}} platformunda otomatik olarak temel planınıza kayıt olursunuz. Daha fazla bilgi için {{supportEmail}} ile iletişime geçin.',
          userRoleMessage: '{{companyName}} platformunda kullanıcı olarak kayıt olursunuz. Şirketinize erişmek için giriş yapın.',
        },
        amazonRegistration: {
          selectYourCompany: 'Şirketinizi seçin',
          selectCompanyDescription: 'Katılmak istediğiniz şirketi seçin.',
          searchCompanies: 'Şirket ara...',
          finishRegistration: 'Bitir',
          cantFindCompany: 'Tesisinizi bulamıyor musunuz?',
          cantFindCompanyStill: 'Yardıma mı ihtiyacınız var?',
          cantFindCompanyDescription:
            'Organizasyonunuzda zaten kayıtlı bir şirket hesabı varsa ve katılmak istiyorsanız, aşağıdaki seçeneklerden birini izleyin.',
          cantFindCompanyOptionOne: 'Lütfen <a href="mailto:{{supportEmail}}"><strong>{{supportEmail}}</strong></a> ile iletişime geçin.',
          companyRequired: 'Devam etmek için lütfen bir şirket seçin',
          registrationSuccess: 'Hesap başarıyla oluşturuldu! Lütfen giriş yapın.',
          registrationError: 'Hesap oluşturulamadı. Lütfen tekrar deneyin.',
          back: 'Geri',
          addCompany: 'Tesis Ekle',
          addCompanyTitle: 'Yeni Tesis Ekle',
          addCompanyDescription: 'Ana şirket altında yeni bir tesis oluşturun.',
          selectParentCompany: 'Ana şirketi seçin',
          companyName: 'Tesis adı',
          companyNamePlaceholder: 'örn., YYZ1',
          companyNameHelperText: '3 harfli tesis kodunu ve ardından 1-2 basamak girin (örn., YYZ1)',
          validatingAirportCode: 'Tesis kodu kontrol ediliyor...',
          invalidAirportCode: 'Tesis kodu bulunamadı',
          networkError: 'Ağ hatası. Lütfen tekrar deneyin.',
          validAirportCode: '{{municipality}}, {{country}}',
          companyNameRequired: 'Şirket adı gereklidir',
          parentCompanyRequired: 'Ana şirket gereklidir',
          invalidCompanyNameFormat: 'Şirket adı bir tesis kodunun ardından 1-2 basamak olmalıdır (örn., YYZ1, YYZ12)',
          createCompanySuccess: '{{name}} şirketi başarıyla oluşturuldu!',
          createCompanyError: 'Şirket oluşturulamadı. Lütfen tekrar deneyin.',
          cannotSelectFacility: 'Bir tesis altında şirket oluşturulamaz. Lütfen bir ana şirket seçin.',
          pendingCompanySelected: 'Yeni şirket "{{name}}" kayıt işlemini tamamladığınızda oluşturulacaktır.',
        },
      },
      calculateLeak: {
        index: {
          loadingLeakError: 'Kaçak verileri yüklenirken beklenmeyen bir hata oluştu',
          calculatingError: 'Hesaplama sırasında beklenmeyen bir hata oluştu',
          dbMeasured: 'Ölçülen Db',
          calculate: 'Hesapla',
          calculating: 'Hesaplanıyor...',
          outflowCoefficient: 'Dış Akış Katsayısı',
          kwhPerYear: 'kWh/yıl',
        },
      },
      companies: {
        commonUsedWords: {
          assignedAdminLicenses: 'Atanan Yönetici Lisansları',
          company: 'Şirket',
          totalAccounts: 'Toplam Hesaplar',
          email: 'E-posta',
          name: 'Ad',
          loadCompanyUsersError: 'Şirket kullanıcıları yüklenemedi. Lütfen daha sonra tekrar deneyin',
          activated: 'Aktif',
          deactivated: 'Deaktif',
          activating: 'Aktifleştiriliyor',
          deactivating: 'Deaktifleştiriliyor',
          deactivate: 'Deaktifleştir',
          activate: 'Aktifleştir',
          set: 'Ayarla',
          youAreGoingTo: 'Bunu yapıyorsunuz',
          areYouSure: 'Emin misiniz?',
          companyNameIsRequired: 'Şirket adı gerekli',
          editCompany: 'Şirketi Düzenle',
          moveCompany: 'Şirketi Taşı',
          createCompany: 'Şirket Oluştur',
          viewHistory: 'Geçmişi Görüntüle',
          exportCSV: 'CSV Dışa Aktar',
          onEssentialPlan: 'Essential planındasınız. Lütfen support@prosaris.ca ile iletişime geçin',
        },
        hubspotTickets: {
          title: 'İşe Alım İlerlemesi',
          searchPlaceholder: 'Tesise göre bilet ara...',
          syncNow: 'Şimdi Senkronize Et',
          syncing: 'Senkronize ediliyor...',
          syncTooltip: "Bu, HubSpot'tan en son pipeline aşamalarını ve biletleri getirecektir",
          unmappedCompanies: 'Eşleştirilmemiş şirketler',
          notStartedOnboarding: 'İşe alım başlatılmadı',
          instructions:
            'Bunlar PROSARIS platformunda karşılık gelen tesisleri olmayan HubSpot biletleridir. Eşleştirme oluşturmak için lütfen aşağıdaki adımları izleyin:',
          step1: 'PROSARIS platformunda yeni bir tesis oluşturun',
          step2Before: '',
          step2After: 'düğmesine tıklayın',
          noUnmappedTickets: 'Eşleştirilmemiş bilet yok',
          noCompaniesWithoutOnboarding: 'İşe alımı olmayan şirket yok',
          noTicketsInStage: 'Bu aşamada bilet yok',
          loadingPipelines: "Pipeline'lar yükleniyor...",
          loadingTickets: 'Biletler yükleniyor...',
          loadingCompanies: 'Şirketler yükleniyor...',
          errorLoadingPipelines: "Pipeline'lar yüklenirken hata oluştu",
          noPipelinesAvailable: 'Kullanılabilir pipeline yok',
          noStagesAvailable: 'Kullanılabilir aşama yok',
          lastUpdated: 'Son güncelleme: ',
          syncSuccess: 'HubSpot verileri başarıyla senkronize edildi',
          syncPipelineFailed: 'HubSpot pipeline senkronizasyonu başarısız oldu',
          syncTicketsFailed: 'HubSpot biletleri senkronizasyonu başarısız oldu',
        },
        accounts: {
          inviteUsers: {
            title: '{{companyName}} için kullanıcıları davet et',
            emailAddresses: 'Kullanıcı e-posta adresleri',
            emailsRequired: 'Kullanıcı e-posta adresleri gereklidir',
            successMessage: 'Kullanıcılar başarıyla davet edildi',
            note: 'Her satırda bir e-posta adresi veya virgülle ayrılmış liste girin.',
            tooltip: 'Her kullanıcı davete yanıt verecektir.',
            invite: 'Davet Et',
          },
          accountDialog: {
            companyIsRequired: 'Şirket gerekli',
            roleIsRequired: 'Rol gerekli',
            createAccountSuccessMessage: 'Hesap başarıyla oluşturuldu',
            emailTakenErrorMessage: 'Bu e-posta ile kayıtlı bir hesap sistemde zaten mevcut',
            errorWhileCreatingAccountMessage: 'Hesap oluşturulurken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            changeAccountSuccessMessage: 'Hesap başarıyla güncellendi',
            errorWhileChangingAccountMessage: 'Hesap güncellenirken hata oluştu. Lütfen tekrar deneyin.',
            editAccount: 'Hesabı Düzenle',
            createAccount: 'Hesap Oluştur',
            role: 'Rol',
          },
          changeOwner: {
            changeOwnerMessage: 'Bu hesaba ait kaçak kayıtlarının sahibini de değiştirmek istiyor musunuz?',
            no: 'Hayır, mevcut hesabı koruyun',
          },
          contentCell: {
            loadAccountRolesError: 'Hesap rolleri bilgileri yüklenemedi. Lütfen daha sonra tekrar deneyin.',
            changeRoleSuccessMessage: 'Hesap {{email}} için yeni bir rol atandı',
            changeRoleErrorMessage: 'Hesap {{email}} için rol güncellenirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            editUser: 'Kullanıcıyı Düzenle',
            adminSetPassword: 'Yönetici Şifreyi Ayarla',
            adminSetSubRenewalDate: 'Yönetici Tarafından Ayarlanan Abonelik Yenileme Tarihi',
            resetPassword: 'Şifreyi Sıfırla',
            user: 'Kullanıcı',
            deleteUser: 'Kullanıcıyı Sil',
          },
          index: {
            noUsersToDisplay: 'Görüntülenecek kullanıcı yok',
            changeStatusSuccessMessage: 'Kullanıcı başarıyla {{isActive}}',
            changeStatusErrorMessage: 'Kullanıcı {{isActive}} yapılırken hata oluştu. Lütfen tekrar deneyin',
            changeOwnerSuccessMessage: 'Kayıtlar yeni bir sahibine aktarıldı',
            changeOwnerErrorMessage: 'Kayıtlar yeni sahibine aktarılamıyor. Lütfen daha sonra tekrar deneyin',
            deleteAccountMutationSuccessMessage: 'Hesap {{email}} başarıyla silindi',
            deleteAccountMutationErrorMessage: 'Hesap {{email}} şu anda silinemiyor. Lütfen daha sonra tekrar deneyin',
            resetAccountPassWordSuccessMessage: 'Şifre sıfırlama e-postası başarıyla gönderildi.',
            users: 'kullanıcılar',
            noneAvailable: 'Mevcut değil',
            of: 'nın',
            contactSupport: 'Şirket yönetici lisansları hakkında ek bilgi için lütfen support@prosaris.ca ile iletişime geçin',
            findAccount: 'Hesap Bul',
            placeholder: 'Ad veya e-posta girin...',
            tooltip: 'Kullanıcıları davet edebilmeniz için en az bir şirket yönetici lisansına ihtiyacınız var',
            invite: 'Davet Et',
            alertDialog: {
              messageOne: 'Kullanıcının şifre sıfırlama talebini onaylayın',
              messageTwo: 'Hesap durumundaki değişikliği onaylayın',
              messageThree: 'Hesap silme işlemini onaylayın',
            },
            sendAPasswordResetEmail: 'Aşağıdaki hesap için bir şifre sıfırlama e-postası göndermeye gidiyorsunuz:',
            confirmMessage: 'Devam etmek istiyor musunuz?',
            followingAccount: 'aşağıdaki hesap:',
            delete: 'SİL',
            userCreatedDialogTitle: 'Kullanıcı Şifre Sıfırlama Bağlantısı Başarıyla Gönderildi',
            userCreatedDialogDescription:
              'Kullanıcıya e-posta adresine bir şifre sıfırlama bağlantısı gönderildi. Ayrıca aşağıdaki bağlantıyı da kopyalayabilirsiniz.',
          },
          adminSetPassword: {
            changedUserPasswordSuccessMessage: 'Hesap şifresi başarıyla güncellendi',
            changedUserPasswordErrorMessage: 'Hesap güncellenirken hata oluştu. Lütfen tekrar deneyin.',
            setNewPassword: 'Yeni Şifre Ayarla',
            accountPasswordUpdated: 'Hesap Şifresi Güncellendi',
            accountPasswordUpdatedDescription:
              'Hesap şifresi başarıyla güncellendi. Yeni şifreyi kopyalamak için aşağıdaki düğmeye tıklayabilirsiniz.',
          },
          adminSetSubRenewalDate: {
            title: 'Abonelik Yenileme Tarihini Ayarla',
            subRenewalDate: 'Abonelik Yenileme Tarihi',
            changedSubRenewalDateSuccessMessage: 'Abonelik yenileme tarihi başarıyla güncellendi',
            changedSubRenewalDateErrorMessage: 'Hesap güncellenirken hata oluştu. Lütfen tekrar deneyin.',
          },
          setPassword: {
            automatic: 'Güçlü bir şifre otomatik olarak oluştur',
            manual: 'Şifreyi manuel olarak oluştur',
            copyLinkInstruction: 'Bir sonraki adımda şifreyi görüntüleyip kopyalayabileceksiniz.',
          },
          userCreatedDialog: {
            title: 'Kullanıcı Başarıyla Oluşturuldu',
            description:
              'Yeni kullanıcınız artık platformu kullanmaya başlayabilir. Kullanıcı ayrıca şifresini sıfırlamak için bir bağlantı içeren bir e-posta alacaktır.',
            passwordCopied: 'Şifre panoya kopyalandı',
            passwordResetLinkCopied: 'Şifre sıfırlama bağlantısı panoya kopyalandı',
            copyPassword: 'Şifreyi Kopyala',
            copyPasswordResetLink: 'Şifre Sıfırlama Bağlantısını Kopyala',
          },
          useRoleOptions: {
            notAvailable: '(kullanılmıyor)',
            adminSeatTaken: '(yönetici koltuğu alınmış)',
            allSeatsAreTaken: '(tüm {{numSeats}} koltuklar dolu)',
            adminRolesTitle: 'Yönetici Rolleri',
            roles: {
              superAdmin: 'Ana Yönetici',
              companyAdmin: 'Şirket (Yönetici)',
              superCompanyAdmin: 'Kurumsal (Yönetici)',
              companyRead: 'Şirket (Okuma)',
              superAdminRead: 'Ana Yönetici (Salt Okuma)',
              integrator: 'Entegre Edici',
              auditor: 'Denetçi',
              user: 'Kullanıcı',
              essential: 'Prosaris Essential',
              enterpriseAdmin: 'Kurumsal Yönetici',
            },
            rolesDescriptions: {
              superAdmin: 'Birden fazla şirket üzerinde tam kontrole sahip olma yetkisi.',
              companyAdmin: 'Şirket kayıtlarını görüntüleme, düzenleme ve atama yetkisi.',
              superCompanyAdmin: 'Şirket kayıtları ve kullanıcılar üzerinde tam kontrole sahip olma yetkisi.',
              companyRead: 'Şirket kayıtlarını yalnızca okuma modunda görüntüleme yetkisi.',
              superAdminRead: 'Tüm şirketler için yalnızca okuma erişimine sahip olma yetkisi.',
              integrator: 'Şirketleri ve hesapları yönetmek için üçüncü taraf entegrasyonlarına izin verir.',
              auditor: 'Kaçak kayıtlarının denetimini sağlamak için.',
              user: 'Kendi kayıtlarını oluşturma/güncelleme/silme yetkisi.',
              essential: 'Sınırlı işlevselliğe sahip bir rol.',
              enterpriseAdmin: 'Şirket kayıtları ve kullanıcılar üzerinde tam kontrole sahip olma yetkisi.',
            },
            nonAdminRolesTitle: 'Yönetici Olmayan Roller',
          },
        },
        audits: {
          index: {
            loadAuditsErrorMessage: 'Denetimleri yüklerken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            audits: 'denetimler',
            noAuditsToDisplay: 'Görüntülenecek denetim yok',
            findByAuditorEmail: 'Denetçi E-postasına Göre Bul',
            placeholder: 'Denetçi e-posta adresini yazın...',
          },
        },
        companyTabs: {
          recordLock: {
            message: 'Bu işlevin kilidini açmak için bir kayıt oluşturup platforma yükleyin.',
          },
          facility: {
            index: {
              facilityNameIsRequired: 'Tesis Adı gereklidir',
              hoursYearlyIsRequired: 'Yıllık Toplam Saat gereklidir',
              totalHoursYearly: "Yıllık Toplam Saat 8760'ı geçemez",
              invalidPhoneNumber: 'Geçersiz telefon numarası',
              createErrorMessage: 'Saat x Vardiyalar 24 saati geçemez',
              loadFacilityErrorMessage: 'Tesisi yüklerken hata oluştu. Lütfen daha sonra tekrar deneyin',
              createFacilitySuccessMessage: 'Tesis başarıyla oluşturuldu',
              createFacilityErrorMessage: 'Tesis oluşturulurken hata oluştu. Lütfen daha sonra tekrar deneyin',
              changeFacilitySuccessMessage: 'Tesis başarıyla güncellendi',
              changeFacilityErrorMessage: 'Tesis güncellenirken hata oluştu. Lütfen tekrar deneyin',
              facilityName: 'Tesis Adı',
              abbreviation: 'Kısaltma',
              address: 'Adres',
              enterALocation: 'Bir konum girin',
              tooltip: 'Enerji Yönetimi faaliyetleri için, ayrıca Rapor Onaylayıcı',
              energyMgtOwner: 'Enerji Yönetimi Sahibi',
              title: 'Unvan',
              phone: 'Telefon',
              tooltipTwo: 'Çözüm yenilemeleri ve genel hesap sorunları için',
              accountOwner: 'Hesap Sahibi',
              manufacturingArea: 'Üretim Alanı',
              size: 'Boyut',
              unit: 'Birim',
              hoursOfOperation: 'Çalışma Saatleri',
              auditFrequency: 'Denetim Sıklığı',
            },
            operationHours: {
              daysPerWeek: 'Gün/Sıra',
              shiftsPerDay: 'Vardiya/Gün',
              hoursPerShift: 'Saat/Vardiya',
              weeksPerYear: 'Yıl başına 52 hafta',
              totalHoursYearly: 'Toplam = Saat/Yıl',
            },
            constants: {
              constant: 'Sabit',
              monthly: 'Aylık',
              threeMonth: '3 Aylık',
              fourMonth: '4 Aylık',
              sixMonth: '6 Aylık',
              nineMonth: '9 Aylık',
              annual: 'Yıllık',
              sqft: 'Kare Fit [SQFT]',
              sqm: 'Kare Metre [SQM]',
            },
          },
          index: {
            users: 'Kullanıcılar',
            devices: 'Cihazlar',
            facility: 'Tesis',
            energy: 'Enerji',
            seu: "SEU'lar - Bileşenler",
            enpi: 'EnPIs/EnBs',
            routes: 'Rotalar',
            audit: 'Denetimler',
            comingSoon: 'Yolda...',
          },
        },
        enpis: {
          index: {
            loadEnpisErrorMessage: 'EnPIs yüklenirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            createEnpisSuccessMessage: 'EnPIs başarıyla oluşturuldu',
            createEnpisErrorMessage: 'EnPIs oluşturulurken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            changeEnpisSuccessMessage: 'EnPIs başarıyla güncellendi',
            changeEnpisErrorMessage: 'EnPIs güncellenirken hata oluştu. Lütfen tekrar deneyin.',
            showHistory: 'Geçmişi Göster',
          },
        },
        changeHistory: {
          bulkOperation: 'toplu işlem olarak',
          details: 'ayrıntılar',
          created: 'oluşturuldu',
          updated: 'güncellendi',
          componentTypes: {
            enpis: 'EnPIs',
            companies: 'Şirketler',
          },
          history: 'Geçmiş',
          noHistory: 'Geçmiş Yok',
        },
        energy: {
          index: {
            utilProvider: 'Kamu Hizmetleri Sağlayıcısı',
            energyUse: 'Enerji Kullanımı ve Tüketim Türü',
            error: {
              loadFacility: 'Tesis yüklenemedi. Lütfen daha sonra tekrar deneyin',
              loadEnergy: 'Enerji verileri yüklenemedi. Lütfen daha sonra tekrar deneyin',
              loadUtilProviderLogo: 'Kamu hizmetleri sağlayıcısının logosu yüklenemedi. Lütfen daha sonra tekrar deneyin',
              createEnergy: 'Enerji verileri oluşturulamadı. Lütfen daha sonra tekrar deneyin',
              createUtilProviderLogo: 'Kamu hizmetleri sağlayıcısının logosu yüklenemedi. Lütfen daha sonra tekrar deneyin',
              updateEnergy: 'Enerji verileri güncellenemedi. Lütfen daha sonra tekrar deneyin',
              deleteUtilProviderLogo: 'Kamu hizmetleri sağlayıcısının logosu silinemedi. Lütfen daha sonra tekrar deneyin',
            },
            success: {
              createEnergy: 'Enerji verileri başarıyla oluşturuldu',
              updateEnergy: 'Enerji verileri başarıyla güncellendi',
            },
          },
          utilProvider: {
            index: {
              costOfEnergy: 'Enerji Maliyeti',
              energySources: 'Enerji Kaynakları',
              incentiveRate: 'Teşvik Oranı',
              per: 'Başına',
              validations: {
                utilProviderIsRequired: 'Kamu hizmetleri sağlayıcısı gerekli',
                costOfEnergyIsRequired: 'Enerji maliyeti gerekli',
                costOfEnergyMustBeNumber: 'Enerji maliyeti bir sayı olmalıdır',
                costOfEnergyMustBeGreaterThanZero: "Enerji maliyeti 0'dan büyük olmalıdır",
                costOfRebateMustBeAtLeatZero: 'İade maliyeti en az 0 olmalıdır',
                costOfRebateMustBeNumber: 'İade maliyeti bir sayı olmalıdır',
              },
            },
            UtilProviderLogo: {
              error: {
                fileSize: "Dosya boyutu 1 MB'dan az olmalıdır",
                preview: 'Resim önizlemesi başarısız oldu',
              },
              logo: 'Logo',
              addLogo: 'Logo Ekle',
              removeLogo: 'Logoyu Kaldır',
            },
            EnergySources: {
              energySource: 'Enerji Kaynağı',
              percentage: 'Yüzde',
              selectEnergySource: 'Enerji kaynağını seçin',
              addEnergySource: 'Enerji kaynağı ekle',
              totalPercentage: 'Toplam yüzde',
              mustBeEqualTo100: '(100% olmalıdır)',
              constants: {
                energySources: {
                  NATURAL_GAS: 'Doğalgaz',
                  FUEL_OIL: 'Akaryakıt',
                  DIESEL: 'Dizel',
                  GASOLINE: 'Benzin',
                  PROPANE: 'Propan',
                  COAL: 'Kömür',
                  WIND: 'Rüzgar',
                  GEOTHERMAL: 'Jeotermal',
                  BIOMASS: 'Biyokütle',
                  STEAM: 'Buhar',
                  COMPRESSED_AIR: 'Basınçlı Hava',
                  CHILLED_WATER: 'Soğutulmuş Su',
                  NUCLEAR: 'Nükleer',
                  HYDRO: 'Hidroelektrik',
                  SOLAR: 'Güneş',
                },
              },
            },
          },
          energyUse: {
            index: {
              currentCalcApproach: 'Mevcut Hesaplama Yaklaşımı',
              currentCalcApproachMessage:
                "Bu hesaplama yaklaşımı, kullanıcı bunu değiştirmediyse varsayılan olarak tüm 'Enerji Maliyeti' alanlarına uygulanmaktadır.",
              alertTitle: 'Hesaplama Yaklaşımını Sıfırlama',
              alertMessageOne: "Bu işlem, tüm 'Enerji Maliyeti' alanları için mevcut hesaplama yaklaşımının kullanımını durduracaktır.",
              alertMessageTwo: 'Lütfen bu değişikliğin mevcut kayıtları etkilemeyeceğini unutmayın.',
              alertMessageThree: 'Sıfırlamayı devam ettirmek istiyor musunuz?',
            },
            ReportType: {
              calcApproach: 'Hesaplama Yaklaşımı',
              constants: {
                calculations: {
                  FIXED: 'Sabit Verimlilik',
                  USDOE: 'ABD DoE',
                  NREL: 'NREL Bölüm 22',
                },
              },
              setAsCurrent: 'Mevcut olarak ayarla',
              setAsCurrentMessage: "Bu hesaplama yaklaşımı, gelecekte tüm 'Enerji Maliyeti' alanları için kullanılacaktır.",
            },
            calculations: {
              FixedEfficiency: {
                validations: {
                  efficiencyMustBeGreaterThanZero: 'Verimlilik 0 veya daha büyük olmalıdır',
                  efficiencyMustBeNumber: 'Verimlilik bir sayı olmalıdır',
                  operationHoursMustBeGreaterThanZero: 'Çalışma saatleri 0 veya daha büyük olmalıdır',
                  operationHoursMustBeLessThan8760: "Çalışma saatleri 8760'dan az olmalıdır",
                  operationHoursMustBeNumber: 'Çalışma saatleri bir sayı olmalıdır',
                },
              },
              UsDoe: {
                loaded: 'Yüklü',
                unloaded: 'Boşaltılmış',
                calcSummary: 'Hesaplama Özeti',
                currentOperatingSystems: 'Mevcut İşletim Sistemleri',
                noCompsFoundAddCompOne: 'Hiç kompresör bulunamadı. Bir kompresör ekleyin',
                noCompsFoundAddCompTwo: 'yukarıdaki sekmeden.',
                help: {
                  nameplateHpPath:
                    "Türetildiği yer: SEU'lar - Bileşenler → Kompresör Tasarım Verileri → {compressorTag} → Plaka Beygir Gücü",
                  nameplateCapacityPath:
                    "Türetildiği yer: SEU'lar - Bileşenler → Kompresör Tasarım Verileri → {compressorTag} → Plaka Kapasitesi",
                  motorEfficiencyPath:
                    "Türetildiği yer: SEU'lar - Bileşenler → Kompresör Tasarım Verileri → {compressorTag} → Motor Verimliliği",
                  pressureSetpointPath:
                    "Türetildiği yer: SEU'lar - Bileşenler → Kompresör Tasarım Verileri → {compressorTag} → Basınç Ayar Noktası",
                  operatingHoursPath: 'Varsayılan kaynağı: Tesis → Çalışma Saatleri',
                  aggregateElectricRatePath: 'Türetildiği yer: Enerji → Kamu Hizmetleri Sağlayıcısı → Enerji Maliyeti',
                  loadedAutoFromUnloaded: 'yüksüzden otomatik',
                  unloadedAutoFromLoaded: 'yüklüden otomatik',
                },
              },
            },
          },
        },
        compressors: {
          compressorDialog: {
            plateError: 'Plaka yüklenirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            dataSheetError: 'Veri sayfası yüklenirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            createSuccess: 'Kompresör {{tag}} oluşturuldu',
            createError: 'Kompresör oluşturulurken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            createCompressor: 'Kompresör Ekle',
            selectTemplate: 'Bir kompresör seç...',
            templatesError: 'Kompresör aramaları yüklenemedi. Lütfen daha sonra tekrar deneyin.',
            searchPlaceholder: 'Model veya marka ile ara... (örn: G11-100, Atlas Copco)',
            templateDescription:
              'Vidalı tip bir kompresör, mevcut kompresörler listesinden seçilerek veya bilgilerin manuel olarak girilmesiyle eklenebilir. Listeden bir kompresör seçerseniz, kalan bilgiler otomatik olarak doldurulur. Bilgileri daha sonra her zaman ince ayar yapabilirsiniz. Pistonlu ve Santrifüj tipi kompresörler manuel olarak girilmelidir.',
            quickSelect: 'Hızlı Seçim',
            quickSelectDescription: 'Mevcut kompresör aramalarından seçin',
            basicInfo: 'Temel Bilgiler',
            basicInfoDescription: 'Genel kompresör kimlik bilgileri',
            technicalSpecifications: 'Teknik Özellikler',
            technicalSpecificationsDescription: 'Performans ve operasyonel parametreler',
            documentation: 'Dokümantasyon',
            documentationDescription: 'Kompresör dosyalarını ve belgelerini yükle',
            compressorSpecifications: 'Kompresör Özellikleri',
            nameplate: 'İsim Levhası',
            motor: 'Motor',
            fullLoad: 'Tam Yük',
            pressure: 'Basınç',
            other: 'Diğer',
            compressorFiles: 'Kompresör Dosyaları',
            datasheetDisplayError: 'Veri sayfası dosyası görüntülenemedi',
            datasheetProcessError: 'Veri sayfası dosyası işlenemedi',
          },
          compressorFile: {
            tip: 'Dosya Ekle',
            removeFile: 'Dosyayı Kaldır',
            removeImage: 'Resmi Kaldır',
            title: 'Kompresör {{prop}} silme işlemini onaylayın',
            proceed: 'Devam etmek istiyor musunuz?',
          },
          compressorForm: {
            compTagIsReq: 'Kompresör Etiketi gerekli',
            controlIsReq: 'Kontrol gereklidir',
            hpMustBeNum: 'Güç plakası HP bir sayı olmalıdır',
            capMustBeNum: 'Güç plakası kapasitesi bir sayı olmalıdır',
            motorEffMustBeNum: 'Motor verimliliği bir sayı olmalıdır',
            motorVoltMustBeNum: 'Motor voltajı bir sayı olmalıdır',
            loadMustBeNum: 'Tam yük akımı bir sayı olmalıdır',
            loadInputMustBeNum: 'Tam yük giriş gücü bir sayı olmalıdır',
            pressureMustBeNum: 'Nominal basınç bir sayı olmalıdır',
            setpointMustBeNum: 'Basınç ayar noktası bir sayı olmalıdır',
            airMustBeNum: 'Toplam hava depolama boyutu bir sayı olmalıdır',
            addImage: 'Resim ekle',
            addFile: 'Dosya ekle',
          },
          constants: {
            compressorTypes: {
              ROTARY_SCREW: 'Rotary Vidalı',
              RECIPROCATING: 'Pistonlu',
              CENTRIFUGAL: 'Santrifüj',
            },
            rotaryScrew: {
              loadUnloadOilFree: 'Yükleme/Boşaltma – Yağsız',
              loadUnload1Gal: 'Yükleme/Boşaltma (1 gal/CFM)',
              loadUnload3Gal: 'Yükleme/Boşaltma (3 gal/CFM)',
              loadUnload5Gal: 'Yükleme/Boşaltma (5 gal/CFM)',
              loadUnload10Gal: 'Yükleme/Boşaltma (10 gal/CFM)',
              ivmWithBlowdown: 'Giriş Vanası Modülasyonu (Boşaltma Olmadan)',
              ivmWithoutBlowdown: 'Giriş Vanası Modülasyonu (Boşaltma ile)',
              variableDisplacement: 'Değişken Deplasman',
              vsdWithUnloading: 'VSD ile Boşaltma',
              vsdWithStopping: 'VSD ile Durdurma',
            },
            reciprocating: {
              reciprocatingOnOffControl: 'Aç/Kapa Kontrolü',
              reciprocatingLoadUnload: 'Yükleme/Boşaltma',
            },
            centrifugal: {
              centrifugalInletIgv: 'IBV ile Boşaltma',
              centrifugalInletIbv: 'IGV ile Boşaltma',
            },
          },
          contentCell: {
            min: '% en az 0 olmalıdır',
            max: "% 100'den fazla olamaz",
            max150: "% 150'den fazla olamaz",
            typeError: 'Yük geçerli bir yüzde olmalıdır',
            setpointMustBeNum: 'Kompresör Ayar Noktası bir sayı olmalıdır',
            flowMustBeNum: 'Kompresör Akışı bir sayı olmalıdır',
            pressureSetpointMustBeNum: 'Sistem Basınç Ayar Noktası bir sayı olmalıdır',
            measuredFlowMustBeNum: 'Sistem Ölçülen Akış bir sayı olmalıdır',
            dateTime: 'Tarih ve Saat Seçin',
            active: 'AKTİF',
            off: 'KAPALI',
            trim: 'trim',
            baseLoad: 'temel Yük',
          },
          index: {
            error: 'Kompresörleri yüklerken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            nameplateError: 'Plakayı yüklerken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            dataSheetError: 'Veri sayfasını yüklerken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            changeCompSuccess: 'Kompresör başarıyla güncellendi.',
            changeCompError: 'Kompresörü güncellerken hata oluştu. Lütfen tekrar deneyin.',
            deleteCompSuccess: 'Kompresör başarıyla silindi.',
            deleteCompError: 'Kompresörü silerken hata oluştu. Lütfen tekrar deneyin.',
            createCompNameplateSuccess: 'Kompresör plakasını başarıyla yüklendi.',
            createCompNameplateError: 'Plakayı yüklerken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            deleteCompNameplateSuccess: 'Kompresör plakasını başarıyla silindi.',
            deleteCompNameplateError: 'Kompresör plakasını silerken hata oluştu. Lütfen tekrar deneyin.',
            createCompDataSheetSuccess: 'Kompresör veri sayfasını başarıyla yüklendi.',
            createCompDataSheetError: 'Veri sayfasını yüklerken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            deleteCompDataSheetSuccess: 'Kompresör veri sayfasını başarıyla silindi.',
            deleteCompDataSheetError: 'Kompresör veri sayfasını silerken hata oluştu. Lütfen tekrar deneyin.',
            changeCompanyCompSuccess: 'Sistem verileri başarıyla güncellendi.',
            changeCompanyCompError: 'Sistem verilerini güncellerken hata oluştu. Lütfen tekrar deneyin.',
            compDesignData: 'Kompresör Tasarım Verileri',
            comp: 'Kompresörler:',
            addComp: 'Kompresör Ekle',
            editCompPermission: 'Kompresörü düzenlemek için bir yönetici lisansına ihtiyacınız var. Lütfen iletişime geçin.',
            selectOption: 'Bir seçenek seçin',
            undoChanges: 'Değişiklikleri Geri Al',
            selectComp: 'Yukarıdan bir kompresör seçin.',
            noCompsFound: 'Kompresör bulunamadı.',
            compRunningState: 'Kompresör Çalışma Durumu',
            compRunningStateLogs: 'Compressor Running State Logs',
            hiddenCompressors: 'Hidden compressors',
            hiddenCompressorsCount: '{{count}} hidden',
            showHiddenCompressors: 'Show {{count}} deleted',
            hideHiddenCompressors: 'Hide {{count}} deleted',
            saveRunningState: 'Save running state',
            discardChanges: 'Discard changes',
            runningStateDirty: 'You have unsaved changes.',
            unsavedChangesConfirm: 'Discard your unsaved changes?',
            compressorDeleted: 'Deleted',
            snapshotHistoryEmpty: 'No earlier states yet — changes will appear here.',
            snapshotHistoryColumnTimestamp: 'Timestamp',
            snapshotHistoryColumnStatus: 'Status',
            snapshotHistoryColumnTrigger: 'Change',
            snapshotStatus: '{{active}}/{{total}} compressors active',
            snapshotGroupToday: 'Today',
            snapshotGroupYesterday: 'Yesterday',
            snapshotCurrent: 'Current',
            snapshotCurrentSubtitle: 'Live state',
            snapshotTrigger: {
              create: 'Created',
              update: 'Edited',
              delete: 'Deleted',
              companyEdit: 'System update',
              backfill: 'Initial state',
            },
            viewingSnapshotPrefix: 'Viewing snapshot from',
            returnToCurrent: 'Return to current',
            noCompsFoundAddComp: 'Kompresör bulunamadı. Yukarıdaki bölümden bir kompresör ekleyin.',
            title: 'Kompresör silme işlemini onaylayın.',
            areYouSure: 'Gerçekten silmek istiyor musunuz?',
            compressor: 'kompresör',
            delete: 'sil',
          },
        },
        devices: {
          contentCell: {
            device: 'Cihaz',
            usedByMultipleCompanies: 'birden fazla şirket tarafından kullanılıyor.',
          },
          index: {
            noDevicesToDisplay: 'Bu şirket için kayıt yapan herhangi bir cihaz yok',
            loadingDevicesErrorMessage: 'Şirket cihazları yüklenirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            changeStatusSuccessMessage: 'Cihaz başarıyla {{isActive}}',
            changeStatusErrorMessage: 'Cihaz {{isActive}} yapılırken hata oluştu. Lütfen tekrar deneyin.',
            devices: 'cihazlar',
            findDevice: 'Cihaz Bul',
            placeholder: 'Cihaz kimliğini yazın...',
            activatedOn: 'Etkinleştirildiği Tarih',
            title: 'Cihaz durumundaki değişikliği onaylayın',
          },
        },
        company: {
          deleteCompanySuccessMessage: '{{companyName}} başarıyla silindi',
          deleteCompanyErrorMessage: '{{companyName}} silinirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          needAdminLicense:
            'Bu özelliğe erişmek için bir yönetici lisansına ihtiyacınız var. Lütfen support@prosaris.ca ile iletişime geçin.',
          deleteChildCompanyFirst:
            'Alt şirketler veya hesaplar olan bir şirketi silemezsiniz. Lütfen önce tüm alt şirketleri ve hesapları silin.',
          editSettings: 'Ayarları Düzenle',
          createASubCompany: '{{companyName}} için bir alt şirket oluştur',
          deleteCompany: 'Şirketi Sil',
          cannotCreateChildCompanyDialog: {
            messageOne:
              'Kurumsal hesabınızla oluşturulabilecek maksimum şirket sayısına ulaştınız. Lütfen ek bilgiler için iletişime geçin ',
            messageTwo: 'ek detaylar için.',
          },
          deleteCompanyDialog: {
            title: 'Lütfen şirket silme işlemini onaylayın',
            delete: 'Sil',
            deleting: 'Silmek,',
            permanentlyDeleted: 'veritabanımızdan kalıcı olarak kaldırılacaktır.',
            cannotBeUndone: 'BU İŞLEM GERİ ALINAMAZ.',
          },
        },
        companyDialog: {
          industryIsRequired: 'Sektör gereklidir',
          createLogoErroerMessage: 'Resim yüklerken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          deleteLogoErrorMessage: 'Resmi silerken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          createCompanySuccessMessage: 'Şirket {{name}} oluşturuldu',
          createCompanyErrorMessage: 'Bir şirket oluşturulurken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          changeCompanySuccessMessage: 'Şirket {{name}} güncellendi',
          changeCompanyErrorMessage: 'Şirket parametresini değiştirme işlemi başarısız oldu. Lütfen daha sonra tekrar deneyin.',
          language: 'Dil',
          industry: 'Sektör',
          country: 'Ülke',
          currency: 'Para Birimi',
        },
        companyLogo: {
          setImageErrorMessage: "Dosya boyutu 1 MB'dan az olmalıdır",
          logo: 'Logo',
          add: 'Ekle',
          removeLogo: 'Logoyu Kaldır',
          addLogo: 'Logo Ekle',
        },
        index: {
          loadCompaniesErrorMessage: 'Şirketler listesini yüklerken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          loadAccountsErrorMessage: 'Hesaplar listesini yüklerken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          changeCompaniesSectionWidth: 'Şirketler Bölümü Genişliğini Değiştir',
        },
        sidebar: {
          filterCompanies: 'Şirketleri Filtrele',
          enterAtLeastNChatacters: 'En az {{length}} karakter girin',
          placeholder: 'Şirket adını girin veya e-posta adresini girin',
          myCompany: 'Benim Şirketim',
          childCompanies: 'Alt Şirketler',
          moreCompany: '{{count}} şirket daha',
          moreCompanies: '{{count}} şirket daha',
        },
        routes: {
          commonUsedWords: {
            equipmentNameIsRequired: 'Ekipman adı gereklidir',
            equipmentLocationIsRequired: 'Ekipman konumu gereklidir',
            equipmentCriticalityIsRequired: 'Ekipman kritikliği gereklidir',
            equipmentDescriptionIsRequired: 'Ekipman açıklaması gereklidir',
            name: 'Ad',
            description: 'Açıklama',
            location: 'Konum',
            criticality: 'Kritik Seviye',
            actions: 'İşlemler',
          },
          index: {
            routePlans: 'Rota Planları',
            addRoute: 'Rota Ekle',
            routeRoutesExample: 'Rota örnekleri',
            pieceOfEquipment: '{{count}} ekipman parçası',
            piecesOfEquipment: '{{count}} ekipman parçaları',
            equipment: 'Ekipman',
            metrics: 'Metrikler',
            settings: 'Ayarlar',
            noFloorPlan: 'Bu rota için bir kat planı yüklemediniz',
            addFloorPlan: 'Rota planlamasına görsel olarak başlamak için bir kat planı ekleyin!',
            routeEquipment: 'Rota Ekipmanı',
            routeMetrics: 'Rota Metrikleri',
            metricsForRoute: 'Rota için metrikler',
            totalRecords: 'Toplam Kayıt',
            totalOpenRecords: 'Toplam Açık Kayıt',
            totalClosedRecords: 'Toplam Kapalı Kayıt',
            totalLossPerYear: 'Yıllık Toplam Kayıp',
            totalKwhPerYear: 'Yıllık Toplam kWh',
            routeUpdatedSuccessfully: 'Rota başarıyla güncellendi',
            routeRemovedSuccessfully: 'Rota başarıyla kaldırıldı',
            routeSettings: 'Rota Ayarları',
            removeRoute: 'Rotayı Kaldır',
            deleteRouteWarning:
              'Bu rotayı kaldırmak, rotayı, rota ekipmanlarını ve rota geçmişini sistemden kaldıracaktır, ancak kayıtlarla ilişkilendirilen geçmiş veriler korunacaktır.',
            areYouSure: 'Bu rotayı kaldırmak istediğinizden emin misiniz?',
            warningRemovingRoute: 'Rotayı kaldırmak, rotayı, ekipmanlarını ve geçmişini sistemden kalıcı olarak kaldırır.',
            thisActionCannotBeUndone: 'BU İŞLEM GERİ ALINAMAZ.',
            noFacility: 'Tanımlı bir tesisiniz yok',
            createAFacility: 'Rota planlamaya başlamak için bir tesis oluşturun',
            goToCreateAFacility: 'Tesis oluşturmaya git',
            createAFacilityTooltip: 'Rota planlamaya başlamadan önce bir tesis oluşturmanız gerekiyor.',
          },
          routeBuilder: {
            title: 'Rota Oluşturucu',
            missingFields: 'Yüklenen dosyada eksik alanlar var',
            facility: 'Tesis',
            route: 'Rota',
            enterRoute: 'Rotayı girin',
            addFloorplan: 'Kat Planı Ekle',
            floorplanInstructionsTooltip:
              'Rota oluşturmanıza yardımcı olması için bir kat planı resmi ekleyin. Rota, kaydedildiğinde kat planı üzerine yerleştirilecektir.',
            change: 'Değiştir',
            location: 'Konum',
            enterLocation: 'Konumu girin',
            equipment: 'Ekipman',
            enterEquipment: 'Ekipmanı girin',
            criticality: 'Kritiklik',
            enterCriticality: 'Kritikliği girin',
            description: 'Açıklama',
            enterDescription: 'Açıklamayı girin',
            addEquipment: 'Ekipman Ekle',
            addRoute: 'Rota Ekle',
            downloadTemplate: 'Şablonu indir',
            excelTemplate: 'Excel Şablonu (.xlsx)',
            csvTemplate: 'CSV Şablonu (.csv)',
          },
          fileReader: {
            loadFromFile: 'Dosyadan Yükle',
            instructionsTooltip:
              'Ekipmanları, Excel (.xlsx, .xls) veya CSV (.csv) dosyası yükleyerek içe aktarabilirsiniz. Dosyada şu sütunlar bulunmalıdır: equipment_name, equipment_location, equipment_criticality, equipment_description. Başlamak için sağlanan şablonu indirin.',
          },
          addRouteModal: {
            routeNameTooltip: 'Rota adı nedir?',
            equipmentNameTooltip: 'Bu ekipmanın adı',
            equipmentDescriptionTooltip: 'Bu ekipmanı açıklayın',
            placeholders: {
              routeName: 'örn. Kompresör Odası Rotası',
              routeLocation: 'örn. A Binası, kuzey kanadı',
              equipmentName: 'örn. Kompresör 1',
              equipmentDescription: 'örn. kompresör, kurutucu, pnömatik bağlantılar',
            },
            addRouteFor: 'Şu rota için ekleyin {{facilityName}}',
            giveYourNewRouteAName: 'Yeni rotanıza bir ad verin, tesisteki konumunu tanımlayın ve ilk ekipmanınızı ekleyin',
            routeNameIsRequired: 'Rota adı gereklidir',
            routeLocationIsRequired: 'Rota konumu gereklidir',
            routeName: 'Rota Adı',
            routeLocation: 'Rota Konumu',
            firstPieceOfEquipment: 'İlk ekipman parçası',
            equipmentName: 'Ekipman Adı',
            equipmentCriticality: 'Ekipman Kritikliği',
            equipmentLocation: 'Ekipman Konumu',
            equipmentDescription: 'Ekipman Açıklaması',
            locationTooltip: 'Tesisteki konumunu açıklayın',
            equipmentLocationTooltip: 'Rota içindeki konumunu açıklayın',
            criticalityTooltip: 'Ekipman kritikliğini (ECR) atayın, genellikle 1 ile 5 arası bir değer',
            downloadTemplate: 'Şablonu indir',
            downloadCsvTemplate: 'CSV Şablonunu indir',
            downloadExcelTemplate: 'Excel Şablonunu indir',
            manual: 'Manuel',
            import: 'İçe aktar',
            importedEquipments: 'İçe aktarılan ekipmanlar',
            pleaseImportEquipment: 'Lütfen ekipman içe aktarın veya manuel moda geçin',
            equipmentOrderNote: 'Ekipmanlar dosyada göründükleri sırayla rotaya eklenecektir.',
            addFloorplan: 'Kat planı ekle',
            change: 'Değiştir',
            floorplan: 'Kat planı',
            noValidEquipmentDataFound: 'Dosyada geçersiz ekipman verisi bulundu. Lütfen şablonu kontrol edin.',
            equipmentItemsImportedSuccessfully: '{{count}} ekipman başarıyla içe aktarıldı',
            invalidFileFormat: 'Geçersiz dosya formatı. Lütfen sağlanan şablonu kullanın.',
            floorplanUploadedSuccessfully: 'Kat planı başarıyla yüklendi',
            routeCreatedSuccessfully: 'Rota başarıyla oluşturuldu',
            equipment: 'Ekipman',
            equipments: 'Ekipmanlar',
            addEquipmentBefore: 'Öncesine ekipman ekle',
            addEquipmentAfter: 'Sonrasına ekipman ekle',
            addEquipmentBetween: 'Araya ekipman ekle',
            removeEquipment: 'Ekipmanı kaldır',
            floorplanIsRequired: 'Kat planı gerekli',
          },
          routeViewer: {
            showLabels: 'Etiketleri göster',
            hideLabels: 'Etiketleri gizle',
            showNumbers: 'Numaraları göster',
            hideNumbers: 'Numaraları gizle',
            markerSize: 'İşaretçi boyutu',
            routeOpacity: 'Rota opaklığı',
            zoomIn: 'Yakınlaştır',
            zoomOut: 'Uzaklaştır',
            resetZoom: 'Yakınlaştırıcıyı sıfırla',
            centerView: 'Görünümü ortalama',
            panUp: 'Yukarı',
            panDown: 'Aşağı',
            panLeft: 'Sol',
            panRight: 'Sağ',
            expandControls: 'Kontrolleri göster',
            collapseControls: 'Kontrolleri gizle',
          },
          routeEditorAddEquipmentAction: {
            addingNewEquipment: 'Yeni bir ekipman eklemek, onu seçilen ekipmandan sonra rotaya ekler.',
            addEquipment: 'Ekipman ekle',
          },
          routeEditorAddWaypointAction: {
            waypoint: 'Yol noktası',
            addingNewWaypoint:
              'Yeni bir yol noktası eklemek, seçilen ekipmandan sonra rotanın yönünü değiştirir, ancak rotayı çalıştırırken bir adım değildir.',
            addWaypoint: 'Yol noktası ekle',
          },
          routeEditorEditEquipmentAction: {
            updateEquipment: 'Ekipmanı güncelle',
          },
          routeEditorEditFloorPlan: {
            floorPlan: 'Kat planı',
            chooseFloorplan: 'Kat planı seç',
          },
          routeEditorModal: {
            successRouteUpdated: 'Rota başarıyla güncellendi',
            errorRouteUpdated: 'Rota güncellenirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            successRouteDeleted: 'Rota başarıyla silindi',
            errorRouteDeleted: 'Rota silinirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            successFloorplanUpdated: 'Kat planı başarıyla güncellendi',
            errorFloorplanUpdated: 'Kat planı güncellenirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
            unsavedChanges: 'Kaydedilmemiş değişiklikleriniz var. Çıkmak istediğinizden emin misiniz?',
            back: 'Geri',
            editEquipment: 'Ekipmanı Düzenle',
            youHaventUploadedFloorPlan: 'Bir kat planı yüklemediniz. Bugün bir kat planı yükleyerek görsel düzenlemeyi etkinleştirin.',
            addFloorPlan: 'Kat Planı Ekle',
            addNewEquipment: 'Yeni Ekipman Ekle',
            removeEquipment: 'Ekipmanı Kaldır',
            swapEquipment: 'Ekipmanı Değiştir',
            addWaypoint: 'Yol Noktası Ekle',
            changeFloorplan: 'Kat Planını Değiştir',
            actions: {
              ADD_EQUIPMENT: 'Ekipman Ekle',
              DELETE_NODE: 'Ekipmanı Kaldır',
              SWAP_EQUIPMENT: 'Ekipmanı Değiştir',
              ADD_WAYPOINT: 'Yol Noktası Ekle',
              CHANGE_FLOORPLAN: 'Kat Planını Değiştir',
            },
          },
          routeEditorRemoveEquipmentAction: {
            youAreAboutToRemoveEquipmentFromTheRoute: 'Aşağıdaki ekipmanı rotadan kaldırmak üzeresiniz.',
            youAreAboutToRemoveWaypointFromTheRoute: 'Seçilen yol noktasını rotadan kaldırmak üzeresiniz.',
            youWillNotLoseAnyHistoricalData:
              'Geçmiş verileriniz kaybolmayacak, ancak bu {{type}} rotadan kaldırılacak ve gelecekteki çalışmalarda kullanılamayacaktır.',
            equipment: 'ekipman',
            waypoint: 'yol noktası',
          },
          routeEditorSwapEquipmentAction: {
            replacementEquipmentIsRequired: 'Yedek ekipman gereklidir',
            swappingEquipmentExplanation: 'Ekipman değiştirme, seçilen ekipmanın konumunu başka bir ekipmanla değiştirir.',
            swappingEquipmentCaption: 'Bu, geçmiş verileri etkilemez, ancak rotadaki ekipman sırasını değiştirecektir.',
            selectedEquipment: 'Seçilen Ekipman',
            swapWith: 'Şununla Değiştir',
            selectEquipment: 'Ekipman Seç',
            swapEquipment: 'Ekipman Değiştir',
          },
        },
      },
      companySettings: {
        settings: {
          adminLicenses: {
            aal: 'Atanan Yönetici Lisansları',
            of: 'nın',
            edit: 'Düzenle',
          },
          essentialMode: {
            disable: 'devre dışı bırak',
            enable: 'etkinleştir',
            essential: 'Temel Mod:',
            enabled: 'ETKİN',
            disabled: 'DEVRE DIŞI',
            moveCompany: "Şirket {{company}}'yi Temel Moda taşı",
            affectedCompanies: 'Etkilenen şirket sayısı',
            affectedAccounts: 'Etkilenen hesap sayısı',
            archivedLeak: 'Arşivlenmiş kaçak olay kayıtlarının sayısı',
            applyingChanges:
              'Bu değişiklikleri uygulayarak hesaplar "Temel" rolünü alacaktır. Kullanıcılar, bir kontrol panelinde ve mobil uygulamada {{quota}} en son kaçak olay kaydını görebilecektir. Diğer kayıtlar arşivlenecektir.',
            essentialLabel: 'Alt şirketler için Temel Modu Değiştir',
            turnOffEssential: 'Şirket {{company}} için Temel Modu kapat',
            byApplyingChanges:
              'Bu değişiklikleri uygulayarak tüm hesaplar "Kullanıcı" rolünü alacaktır. Kullanıcılar, tüm kayıtlarını görebilecektir. Tüm kayıtlar arşivden çıkarılacaktır.',
          },
          hubspotSync: {
            disable: 'devre dışı bırak',
            enable: 'etkinleştir',
            hubspot: 'HubSpot Senkronizasyonu',
            enabled: 'ETKİN',
            disabled: 'DEVRE DIŞI',
            enableHubspotSync: '{{company}} için HubSpot senkronizasyonunu etkinleştir',
            disableHubspotSync: '{{company}} için HubSpot senkronizasyonunu devre dışı bırak',
            affectedCompanies: 'Etkilenen şirket sayısı',
            applyingChanges: 'Bu değişiklikleri uygulayarak HubSpot senkronizasyonu {{status}} olacaktır.',
            hubspotLabel: 'Alt şirketler için HubSpot senkronizasyonunu değiştir',
          },
          convertToSuperCompany: {
            title: 'Şirketi yeniden yapılandır',
            newParentCompany: 'Yeni üst şirket',
            confirmChange: 'Değişiklikleri onayla',
            confirmChangeMessage: '{{child}} şirketini {{parent}} şirketinin alt kuruluşu yapmak istediğinizden emin misiniz?',
            convertSuccess: 'Şirket başarıyla yeniden yapılandırıldı',
            convertError: 'Şirket yeniden yapılandırılırken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          },
          deploymentTransfer: {
            title: 'Şirketi Taşı',
            senderTab: 'Kaynak',
            receiverTab: 'Hedef',
            configured: 'Yapılandırıldı',
            checkConfiguration: 'Yapılandırmayı Kontrol Et',
            configuredFrom: 'Taşıma yapılandırması ana şirketten devralındı',
            errorBoundary: 'Şirket taşıma yüklenirken bir hata oluştu.',
            sender: {
              notConfigured: 'Yapılandırılmadı',
              awaitingConnection: 'Bağlantı bekleniyor',
              awaitingS3Config: 'S3 yapılandırması gerekli',
              title: 'Kaynak Yapılandırması',
              description: 'Bu dağıtımı veri aktarımının kaynağı olarak yapılandırın.',
              stepOne: 'Adım 1: Hedef URL yapılandır',
              stepOneDescription: 'Hedef dağıtım URL’sini girin.',
              stepTwo: 'Adım 2: API Anahtarını Paylaş',
              stepTwoDescription: 'API anahtarını kopyalayın ve paylaşın.',
              stepThree: 'Adım 3: S3 Varlık Taşıma',
              stepThreeDescription: 'S3 varlık taşımasını yapılandırın.',
              apiKey: 'API Anahtarı',
              copyKey: 'API Anahtarını Kopyala',
              regenerateKey: 'API Anahtarını Yeniden Oluştur',
              keyCopied: 'API anahtarı kopyalandı',
              keyRegenerated: 'API anahtarı başarıyla yenilendi',
              connected: 'Hedefe bağlandı',
              connectedTo: 'Şirkete bağlandı: {{companyId}}',
              notConnectedWarning: 'Uyarı: Hedefe bağlı değil.',
              targetUrl: 'Hedef URL',
              lambdaFunction: 'Lambda Fonksiyon Adı',
              bucketAutoConfig: 'Bucket’lar otomatik olarak yapılandırılır.',
              saveSuccess: 'Kaynak yapılandırması kaydedildi',
              saveError: 'Kaynak yapılandırması kaydedilemedi',
              regenerateError: 'API anahtarı yenilenemedi',
              deleteConfig: 'Yapılandırmayı Sil',
              deleteConfirmMessage: 'Bu işlem kaynak yapılandırmasını silecektir.',
              deleteSuccess: 'Kaynak yapılandırması silindi',
              deleteError: 'Kaynak yapılandırması silinemedi',
            },
            receiver: {
              notConfigured: 'Yapılandırılmadı',
              title: 'Hedef Yapılandırması',
              description: 'Bu dağıtımı veri aktarımının hedefi olarak yapılandırın.',
              sourceUrl: 'Kaynak URL',
              apiKey: 'API Anahtarı',
              apiKeyPlaceholder: '64 karakterlik API anahtarını yapıştırın',
              invalidApiKey: 'API anahtarı 64 karakter olmalıdır',
              connected: 'Bağlı',
              pending: 'Beklemede',
              connectedFrom: 'Şirketten bağlandı: {{companyId}}',
              saveAndConnect: 'Kaydet ve Bağlan',
              connectionSuccess: 'Bağlantı başarılı',
              handshakePending: 'Yapılandırma kaydedildi. Bağlantı bekleniyor.',
              saveError: 'Yapılandırma kaydedilemedi',
              deleteConfig: 'Yapılandırmayı Sil',
              deleteConfirmMessage: 'Bu işlem hedef yapılandırmasını silecektir.',
              deleteSuccess: 'Hedef yapılandırması silindi',
              deleteError: 'Hedef yapılandırması silinemedi',
            },
            operations: {
              title: 'Aktarım İşlemleri',
              description: 'Veri ve varlıkları hedefe aktarın.',
              notConnected: 'Uyarı: Hedefe bağlı değil.',
              stepTransferData: 'Adım 1: Verileri Aktar',
              stepTransferAssets: 'Adım 2: Varlıkları Aktar',
              transferComplete: 'Aktarım Tamamlandı',
              completed: 'Tamamlandı',
              inProgress: 'Devam Ediyor',
              notStarted: 'Başlatılmadı',
              pending: 'Beklemede',
              transferAll: 'Tüm Koleksiyonları Aktar',
              refreshStatus: 'Durumu Yenile',
              migrateS3: 'S3 Varlıklarını Taşı',
              transferStarted: 'Aktarım başlatıldı',
              transferError: 'Aktarım başlatılamadı',
              s3MigrationStarted: 'S3 taşıma başlatıldı',
              s3MigrationError: 'S3 taşıma başarısız',
              overallStatus: 'Genel Durum',
              totalDuration: 'Toplam Süre',
              completedAt: 'Tamamlandığında',
              initiatedBy: 'Başlatan',
              collection: 'Koleksiyon',
              status: 'Durum',
              documents: 'Belgeler',
              duration: 'Süre',
              assetType: 'Varlık Türü',
              documentsProcessed: 'İşlenen Belgeler',
              parentTransferDescription: 'Ana şirketlerin aktarımı tamamlanmalıdır.',
            },
          },
          index: 'Ayarlar',
        },
        index: {
          loadCompanyError: 'Şirket bilgileri yüklenemiyor. Lütfen daha sonra tekrar deneyin.',
          companySlug: 'Şirket Slugu',
          notSelected: 'Seçilmedi',
          country: 'Ülke',
          accounts: 'Hesaplar',
          currency: 'Para Birimi',
          adminLicenses: 'Yönetici Lisansları',
          totalCustomer: 'Ağaçta Toplam Müşteri Hesapları',
        },
      },
      device: {
        registerDeviceView: {
          registerDevice: 'Cihazınızı Kaydedin',
          toolTip: 'Lütfen kayıt kartınızda veya kutuda seri numarasını bulun.',
          serialNumberIsRequired: 'Seri numarası gereklidir',
          oops: 'Hups!',
          deviceNotFound: 'Cihaz seri numarası bulunamadı',
          deviceFoundNdAssociatedCompany: 'Cihazınız bulundu ve bir şirketle ilişkilidir.',
          deviceFound: 'Cihazınız bulundu.',
          goToLogin: 'Giriş Yap’a Git',
          contactSupport: 'Lütfen destek ile iletişime geçin',
        },
        deviceErrorCodes: {
          'B13:001': 'Cihaz seri numarası bulunamadı',
          'B13:002': 'Cihaz zaten etkinleştirilmiş',
          'B13:003': 'Yönetici e-postası gönderilmedi',
          'B13:004': 'Şirket bulunamadı',
          'B13:005': 'Geçersiz şirket',
          'B13:006': 'Geçersiz tür',
        },
        registerAccountView: {
          createAccountSuccess: 'Hesap başarıyla oluşturuldu',
          createAccountError: 'Hesap oluşturulurken hata oluştu. Lütfen support@prosaris.ca adresinden destek alın',
          registerAccount: 'Hesap oluştur',
          deviceType: 'Cihaz Türü',
          termsMustBeAccepted: 'Şartlar ve koşullar kabul edilmelidir.',
          saleType012Success: 'Cihazınızı kullanmaya başlamak için giriş yapabilirsiniz.',
          saleType3Success: 'Temel kullanıcı olarak eklenmişsinizdir. Şirket yöneticileriniz bilgilendirilmiştir.',
          saleType4Success: {
            companyPlatformFound: 'Şirket Platform lisansı bulundu.',
            dialogOne: 'Bu cihaz yeni bir şirket platform lisansı ile ilişkilidir.',
            dialogTwo: 'Şirketiniz sistemimizde zaten mevcut olabilir.',
            dialogThree: 'Eğer öyleyse, lütfen yöneticinizle iletişime geçin.',
          },
          termsAndConditions: {
            dialogOne: 'Prosaris’i kabul ediyorum.',
            dialogTwo: 'Hizmet Şartları',
            dialogThree:
              "ve yeterince zaman tanındığını onaylıyorum, ayrıca bunun Prosaris yazılımını kullanmamla ilgili önemli şartlar içerdiğini, bu şartların arasında Prosaris'in sorumluluğunun sınırlandırılması ve verilerimin nasıl işleneceği konularının da bulunduğunu anlıyorum.",
          },
          termsOfServiceModal: {
            termsOfService: 'Hizmet Şartları',
          },
          acceptTerms: 'Şartları Kabul Et',
          registerAccountErrorCodes: {
            'B02:001': 'Geçersiz kayıt kodu',
            'B02:002': 'Geçersiz kullanıcı şirketi',
            'B02:003': 'Geçersiz kullanıcı rolü',
            'B02:004': 'E-posta zaten alınmış',
            'B02:005': 'E-posta zaten alınmış',
            'B02:006': 'Hesabınız için şifre sıfırlanamıyor',
            'B02:007': 'Geçersiz kullanıcı şirketi',
            'B02:008': 'Profil fotoğrafı eksik',
            'B02:009': 'Hesap sıfırlaması gereklidir. İşlem başlatıldı',
            'B02:010': 'Hesap devre dışı bırakıldı',
            'B02:011': 'Profil fotoğrafı geçersiz format',
            'B02:012': 'Cihaz zaten bir şirkete kayıtlı',
            'B02:013': 'Seri numarası tanımsız',
            'B02:014': 'Geçersiz tür',
            'B02:015': 'Şifre sıfırlama bağlantısı süresi dolmuş',
            'B02:016': 'Bu şirket için bir hesap oluşturulamadı',
            'B02:017': 'Geçersiz rol',
            'B02:018': 'Geçersiz rol',
            'B02:019': 'Geçersiz kullanıcı şirketi',
            'B02:020': 'Geçersiz kullanıcı rolü',
            'B02:021': 'Kullanıcı bu şirkete ait değil',
          },
          whichProduct: 'Hangi ürününüzün var?',
        },
        devicesView: {
          serialNumbersIsReq: 'Seri numaraları gereklidir',
          failedToCopy: 'Panoya kopyalanan seri numaraları başarısız oldu',
          invalidFormat: 'Bir veya daha fazla cihazın geçersiz formatı var. Lütfen kontrol edin ve tekrar deneyin.',
          devices: 'Cihazlarınızı kaydedin',
          deviceSerialNumber: 'Cihaz Seri Numarası(ları)',
          note: 'Her seri numarasını yeni bir satıra veya virgülle ayırarak girin.',
          title: 'Lütfen kayıt kartınızda veya kutuda seri numarasını bulun.',
          register: 'Kaydet',
          deviceRegistrationStatus: 'Cihaz Kayıt Durumu',
          success: 'Başarılı',
          noDeviceFound: 'Cihaz bulunamadı.',
          failed: 'Başarısız',
          copyFailed: 'Başarısız seri numaralarını panoya kopyala',
        },
      },
      errors: {
        notFoundView: {
          title: 'Aradığınız sayfa burada değil',
          description: 'Ya şüpheli bir yol denediniz ya da buraya yanlışlıkla geldiniz. Her neyse, lütfen navigasyonu kullanmayı deneyin.',
        },
        accountNotFound: {
          title: 'Hesap Bulunamadı',
          description:
            'Lütfen tekrar deneyin! Eğer sorun devam ederse, hesabınız şu anda devre dışı olabilir veya yönetici tarafından henüz başlatılmamış olabilir. Lütfen yöneticinizle iletişime geçin.',
          logout: 'Çıkış Yap',
        },
      },
      integration: {
        index: {
          loggingInError: "Prosaris'e giriş yaparken hata oluştu.",
        },
      },
      leakRecordDetails: {
        assignedActions: {
          actionImages: 'Görüntülenecek resim yok.',
          activeActionRecord: {
            updateAssignmentSuccess: 'Atanan eylem güncellendi.',
            updateAssignmentError: 'Atanan eylemi güncellerken hata oluştu.',
            deleteImageSuccess: 'Atanan resim silindi.',
            deleteImageError: 'Atanan eylem resmini silerken hata oluştu.',
            confirmMarkAction:
              'Bu görevi tamamlamak, kaydı tamamlanmış olarak işaretleyecek ve ilişkili tüm eylemleri etkisiz hale getirecektir. Devam etmek istediğinize emin misiniz?',
            confirmDeleteImage: 'Bu resmi silmek istiyor musunuz?',
          },
          index: 'Bir kayıt için atanan eylemleri yüklerken hata oluştu.',
        },
        audio: {
          noAudioAvailable: 'Ses verisi mevcut değil',
          errorDownloadingAudio: 'Ses indirilirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          playPause: 'Oynat / Duraklat',
          generateRegion: 'Bölge Oluştur',
          removeLastRegion: 'Son Bölgeyi Kaldır',
          generateMarker: 'İşaretçi Oluştur',
          removeLastMarker: 'Son İşaretçiyi Kaldır',
          toggleTimeline: 'Zaman Çizelgesini Değiştir',
          download: 'İndir',
        },
        audit: {
          updateAuditSuccess: 'Denetim başarıyla güncellendi',
          updateAuditError: 'Yorum kaydedilirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          createAuditSuccess: 'Denetim başarıyla oluşturuldu',
          createAuditError: 'Denetim oluşturulurken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          deleteAuditSuccess: 'Denetim başarıyla silindi',
          deleteAuditError: 'Denetimi silerken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          noComment: 'Yorum yok',
          reviewComments: 'Yorumları İncele',
          reviewedBy: 'İnceleyen:',
          auditDate: 'Denetim Tarihi:',
          deleteAudit: 'Denetimi Sil',
          reviewedNoComments: 'Yorum Yok Olarak İncelendi',
          auditComments: 'Denetim Yorumları',
          saveComment: 'Yorumu Kaydet',
          discardChanges: 'Değişiklikleri İptal Et',
        },
        changeHistory: {
          created: 'oluşturuldu',
          updated: 'güncellendi',
          deleted: 'silindi',
          transferred: 'aktarıldı',
          synced: 'senkronize edildi',
          leak: 'Kayıt',
          images: 'Görüntü',
          audit: 'Denetim',
          audio: 'Ses',
          history: 'Geçmiş',
          noHistory: 'Geçmiş Yok',
          bulk: 'toplu işlem olarak',
          details: 'ayrıntılar',
          unset: 'belirlenmemiş',
        },
        fft: {
          fft: 'FFT',
          fftAvg: 'FFT Ortalaması',
          notApplicable: 'Uygulanamaz',
          chartLayers: 'grafik-katmanları',
          avg: 'Ortalama',
          all: 'Tümü',
          playing: 'Çalınıyor...',
          showTimeSeries: 'Zaman Serisini Göster',
          xAxis: 'Frekans (Hz)',
          yAxis: 'Büyüklük',
          frame: 'Kare',
          speed: 'Hız',
          play: 'Oynat',
          pause: 'Duraklat',
          resetZoom: 'Yakınlaştırmayı Sıfırla',
        },
        form: {
          updateLeakSuccess: 'Başarıyla güncellendi.',
          updateLeakError: 'Kaçak güncellenirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          alertTitle: {
            partOne: 'Kayıt şu durumda',
            partTwo: 'sadece okunur',
            partThree: 'mod.',
          },
          alertDialog: {
            dialogOne: 'Ancak, aşağıdaki özellikler değiştirilebilir:',
            dialogTwo: 'Eylem Durumu',
          },
          GPSLocation: 'GPS Konumu',
          completedOn: 'Tamamlanma Tarihi:',
          lastSaved: 'Son Kaydedilen:',
          updateConfirmMessage:
            'Bu kaydın tamamlanması, tüm ilişkili eylemleri etkisiz hale getirecektir. Devam etmek istediğinize emin misiniz?',
          updateConfirmTitle: 'Kayıt Tamamlamayı Onayla',
          smartTagHelp: 'PROSARIS Smart Tags hakkında daha fazla bilgi alın',
        },
        images: {
          removeSuccess: 'Resim başarıyla silindi.',
          removeError: 'Kaçak kaydı resmini silinemiyor. Lütfen daha sonra tekrar deneyin.',
          text: 'Bu resmi silmek istediğinizden emin misiniz?',
          addImages: 'Resim ekle',
          additionalImages: 'Ek Görüntüler',
          noAdditionalImages: 'Ek görüntü yok',
          uploadSuccess: 'Resim(ler) başarıyla yüklendi.',
          uploadError: 'Resim yüklenemiyor. Lütfen daha sonra tekrar deneyin.',
          maxImagesReached: 'Kayıt başına en fazla 10 ek görüntü.',
          tooManyFiles: '{{count}} resim eklenemiyor. Sadece {{remaining}} tane daha eklenebilir.',
        },
        index: {
          title: 'Kayıt',
          loadingError: 'Kaçak kaydını yüklerken hata oluştu. Lütfen tekrar deneyin.',
          unsavedMessage: "'Tamam'a basarak, kaydedilmemiş tüm değişikliklerin silineceğini onaylıyorsunuz.",
          notAnAuditor: 'Bir denetçi değilsiniz.',
          anEssential: 'Temel planındasınız.',
          showHistory: 'Geçmişi Göster',
        },
        massFlow: {
          recalculating: 'Kaçak parametre ayarlarına göre Akış/Kayıp yeniden hesaplanıyor...',
          warning: 'Giriş değerleri değişti veya hesaplama güncel değil, Akış ve Kayıp değerlerini yenilemek için `Yenile` butonuna basın.',
          calculatingError: 'Kütle akışını hesaplarken hata oluştu. Lütfen tekrar deneyin.',
          noValue: 'Değer Yok',
          calculatingSuccess: 'Akış/Kayıp Yeniden Hesaplandı',
          recalculate: 'Yeniden Hesapla',
          calculatorVersion: 'Hesaplama sürümü:',
          noteDialog: {
            dialogOne: 'Kaçak parametre ayarlarını değiştirmek, Akış/Kayıp hesaplamasını güncelleyecektir. Kontrol edin',
            dialogTwo: 'hesaplama içgörüleri',
            dialogThree: 'sayfası için ek bilgi',
          },
        },
        unsavedWarningDialog: {
          recordChanged: 'Kayıt değiştirildi',
          close: 'kapat',
          unsavedChanges: 'Bu kaydın kaydedilmemiş değişiklikleri var. Lütfen bu değişiklikleri kaydetmeyi veya tamamen silmeyi düşünün.',
          discardChanges: 'Değişiklikleri İptal Et',
        },
      },
      leakRecordCreate: {
        form: {
          deviceIDIsRequired: 'Cihaz Kimliği gereklidir',
          dbPeakIsRequired: 'Ölçülen Tepe dB gerekli',
          dbMin: "Ölçülen Tepe dB 0'dan büyük veya eşit olmalıdır",
          dbMax: "Ölçülen Tepe dB 95'ten küçük veya eşit olmalıdır",
          dbError: 'Ölçülen Tepe dB bir sayı olmalıdır',
          imageUploadError: 'Resim yüklenirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          createLeakSuccess: 'Kayıt başarıyla eklendi',
          createLeakError: 'Kayıt oluşturulurken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          basicInfo: 'Temel Bilgiler',
          flowInput: 'Akış Girişi',
          mainGas: 'İlgili Ana Gaz/Bileşen',
          selectComponent: 'Bileşeni Seç',
          selectLeakType: 'Kaçak türünü seç',
          mightBeSomethingHere: 'henüz emin değilim',
          energyLoss: 'Enerji Kaybı',
          selectCompressorType: 'Kompresör Türünü Seç',
          noRoutes: 'Rotalar mevcut değil',
          noEquipment: 'Ekipman mevcut değil',
          noRouteEquipment: 'Rota ekipmanı mevcut değil',
          routeEquipmentInfo: 'Rota Ekipmanı Detayları',
          noLocations: 'Konumlar mevcut değil',
          energyCost: 'Enerji Maliyeti',
          audioRecording: 'Ses Kaydı',
          leakSourceEquipment: 'Kaynak',
          selectComponentType: 'Bileşen türünü seç',
          selectService: 'Hizmeti seç',
          locationAndUser: 'Konum ve Kullanıcı',
          leakEventStatus: 'Olay Durumu',
          low: 'Düşük',
          medium: 'Orta',
          high: 'Yüksek',
          open: 'Açık',
          complete: 'Tamamlandı',
          reset: 'Sıfırla',
        },
        formElectrical: {
          systemVoltages: 'Sistem Gerilimleri',
          source: 'Kaynak',
        },
        images: {
          leakSourceImageCapture: 'Kaynak Görüntü Yakalama',
          add: 'Ekle',
        },
        index: {
          title: 'Kayıt Oluştur',
        },
      },
      leakRecordsList: {
        filters: {
          from: 'Deneyim',
          to: 'İleri',
          qualifier: 'Nitelik',
          savedFilters: 'Kaydedilen Filtreler',
          filter: 'Filtre',
          selectFilter: 'Bir filtre seçin...',
          filterName: 'Filtre Adı',
          filterNameRequired: 'Filtre adı gereklidir',
          filtersNotAvailable: 'Filtreler mevcut değil',
          saveFilterTitle: 'Filtreyi Kaydet',
          deleteSavedFilterTitle: 'Lütfen filtre silme işlemini onaylayın',
          deleteSavedFilterMessage: '“{{savedFilterName}}” filtresini silmek istediğinizden emin misiniz?',
          createFilterSuccess:
            "'{{filter}}' filtresi başarıyla oluşturuldu. Kaydedilen Filtreler → Kayıt Filtreleri altında bulabilirsiniz",
          createFilterError: 'Filtre oluşturulurken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          deleteFilterSuccess: 'Filtre başarıyla silindi',
          deleteFilterError: 'Filtre silinirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          emptyFilter: 'Boş',
        },
        modalAssignUsers: {
          assignLeakRecord: 'Kayıt Atayın',
          selectAUserToAssign: 'Seçilen kayıt(lar) için atanacak kullanıcıyı seçin',
          filterByName: 'İsme göre filtrele',
          filterByEmployeeName: 'Çalışan ismine göre filtrele',
          unexpectedError: 'Beklenmeyen bir hata oluştu',
          noUserFound: 'Kullanıcı bulunamadı',
          assigningActionForSelectedRecords: 'Seçilen kayıt(lar) için eylem atanıyor...',
        },
        modalTransferRecords: {
          transferRecords: 'Kayıtları Aktar',
          selectCompany: 'Şirket Seç',
          selectCompanyPlaceholder: 'Bir şirket seçin',
          selectUser: 'Kullanıcı Seç',
          selectUserPlaceholder: 'Bir kullanıcı seçin',
          noUserFound: 'Kullanıcı bulunamadı',
          unexpectedError: 'Beklenmeyen hata oluştu',
        },
        modalBulkEdit: {
          titleSingleRecord: '{{selectedRecordsCount}} kaydın toplu düzenlemesi',
          title: '{{selectedRecordsCount}} kaydın toplu düzenlemesi',
          selectAField: 'Bir alan seçin',
          verifyAction:
            'Diğer kullanıcılara ait kayıtları güncellemek üzeresiniz. Lütfen aşağıya seçilen kayıtların sayısını girerek onaylayın.',
          matchCountError: 'Seçilen kayıt sayısıyla eşleşmelidir ({{selectedRecordsCount}})',
          moreThanOneType: 'Seçilen kayıtların birden fazla türü var. Bazı alanlar toplu düzenleme için kullanılamayabilir.',
          companyFilterRequired:
            'Rota alanlarını düzenlemek için lütfen önce bir Şirket filtresi uygulayın. Rotalar şirkete/tesise özeldir.',
          selectCompanyForRoute:
            'Rotalar şirkete/tesise özeldir. Bir şirket seçildiğinde filtre uygulanacak ve bu pencere kapanacaktır. Kayıtlarınızı yeniden seçmeniz ve toplu düzenlemeyi tekrar açmanız gerekecektir.',
        },
        tableHead: {
          youAreSelecting: 'Seçtiğiniz:',
          visibleRecords: 'görünür kayıtlar',
          andAllUnloadedRecords: 've tüm yüklenmemiş kayıtlar.',
          allRecordsWillBeLoaded: 'Tüm kayıtlar yüklenecek ve seçilecektir.',
          thisCanTakeAWhile: 'Eğer çok sayıda kaydınız varsa bu biraz zaman alabilir.',
          allRecords: 'Tüm kayıtlar, görünmeyenler de dahil.',
          selectAllRecords: 'Tüm kayıtları seç.',
        },
        tableBody: {
          noRecordsToDisplay: 'Görüntülenecek kayıt yok.',
        },
        toolBar: {
          assign: 'Ata',
          assignToSelf: 'Kendime ata',
          assignToSelfDialogTitle: 'Kayıt atamasını onayla',
          assignToSelfDialogMessage: '{{len}} kaydı kendinize atamak istediğinizden emin misiniz?',
          onEssentialPlan: 'Temel planındasınız. Lütfen support@prosaris.ca ile iletişime geçin.',
          bulkEdit: 'Toplu Düzenleme',
          transfer: 'Aktar',
          bulkEditSuccess: '{{len}} kayıt başarıyla güncellendi',
          bulkEditSuccessPlural: '{{len}} kayıt başarıyla güncellendi',
          bulkEditError: 'Kayıtlar güncellenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin',
          export: 'Dışa Aktar',
          exportPDF: 'PDF Dışa Aktar',
          needAdminLicense:
            'Bu özelliğe erişmek için bir yönetici lisansına ihtiyacınız var. Lütfen support@prosaris.ca ile iletişime geçin.',
          create: 'Oluştur',
          deleteRecordMessage: 'Seçilen kaydı silmek istediğinizden emin misiniz?',
          deleteRecordMessagePlural: 'Seçilen kayıtları silmek istediğinizden emin misiniz?',
          permissionDenied: 'İzin reddedildi!',
          notAllowedToDelete: 'Silinmesine izin verilmeyen birinin kaydını seçtiniz. Lütfen seçimden çıkarın.',
          generatingPDF: 'PDF oluşturuluyor...',
          csvExportProcessing: 'Dosyanız işleniyor. Otomatik olarak indirilecek.',
          cannotGeneratePDF:
            'Maalesef, şu anda {{numberSelected}} kaydı tek bir PDF belgesine dışa aktaramıyoruz. Lütfen en fazla {{limitRecords}} kaydı seçin.',
          cannotExportMessage: '{{numberSelected}} kaydı dışa aktarılamıyor.',
          bulkEditLimitExceeded: '{{maxAllowed}} kayıttan fazlası düzenlenemez. Lütfen support@prosaris.ca ile iletişime geçin',
          selectAtLeastOneRecord: 'Lütfen en az bir kayıt seçin',
        },
        index: {
          cannotLoadLeakRecord: 'Üzgünüz, şu anda kaçak kaydını yükleyemiyoruz.',
          successfullyAssignedAllRecords: 'Tüm kayıtlar başarıyla atandı.',
          actionRecordAssigned: 'Eylem kaydı atandı!',
          actionRecordAssignedPlural: 'Eylem kayıtları atandı!',
          errorWhileAssigningLeak: 'Kaçak atarken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          successfullyDeletedAllRecords: 'Tüm kayıtlar başarıyla silindi.',
          successfullyDeletedRecord: '{{length}} kaçak kaydı başarıyla silindi.',
          successfullyDeletedRecordPlural: '{{length}} kaçak kayıtları başarıyla silindi.',
          errorOnRecordsDelete: 'Kayıtları silerken hata oluştu. Lütfen daha sonra tekrar deneyin.',
          leakPreview: 'Önizleme',
          leakRecord: 'Kayıt:',
          failedAssignments: 'Başarısız atamalar ({{failed}})',
          failedAssignmentCodes: {
            'B04:012': 'Kayıt kapatılmış',
          },
          displayedRows: '{{from}}-{{to}} nın {{count}}',
          rowsPerPage: 'Sayfa başına satır:',
          previousPage: 'Önceki sayfa',
          nextPage: 'Sonraki sayfa',
          csvExportSuccess: 'Dışa aktarma başarıyla tamamlandı',
          csvExportError: 'Dışa aktarma sırasında hata oluştu. Lütfen daha sonra tekrar deneyin.',
        },
      },
      tagList: {
        resetTag: 'Etiketi Sıfırla',
        dataExport: {
          smartLeakTagsFormat: 'Smart Tags formatı',
          smartLeakTagsDescription: 'Smart Tags sayfasında bulunan varsayılan alanları içerir',
          standardLeakRecordFormat: 'Standart Kayıt formatı',
          standardLeakRecordDescription: 'Sızıntı kayıtlarına ilgili tüm alanları içerir',
        },
        filters: { smartLeakTagFilters: 'Smart Tag Filtreleri' },
        index: {
          cannotLoadTags: 'Üzgünüz, şu anda Smart Tag yükleyemiyoruz',
          updateLeakSuccess: 'Smart Tag sıfırlaması başarılı.',
          updateLeakError: 'Smart Tag sıfırlanırken hata. Lütfen daha sonra tekrar deneyin.',
          bulkEditSuccess: 'Başarıyla {{len}} Smart Tag sıfırlandı',
          bulkEditSuccessPlural: 'Başarıyla {{len}} Smart Tags sıfırlandı',
          bulkEditError: 'Smart Tags sıfırlanırken hata. Lütfen daha sonra tekrar deneyin.',
          tagsFileName: 'Smart Tags',
          leakFileName: 'Kayıtlar',
        },
        tableBody: {
          title: 'Lütfen etiketi sıfırlama işlemini onaylayın.',
          alertDialog: {
            dialogOne: 'Şu anda şunu deniyorsunuz',
            dialogTwo: 'etiketi sıfırlamak.',
            dialogThree: 'bir kaçak kaydından',
            dialogFour: 'Eylem Durumu: AÇIK',
            dialogFive: 'Devam etmek istiyor musunuz?',
          },
        },
        toolBar: {
          resetTags: 'Etiketleri Sıfırla',
          title: 'Lütfen etiketlerin toplu olarak sıfırlanmasını onaylayın.',
          alertDialog: {
            dialogOne: 'Seçiminiz şunları içeriyor',
            dialogTwo: 'kayıt ile',
            dialogTwoPlural: 'kayıt ile',
            dialogThree: 'Eylem Durumu: AÇIK',
            dialogFour: 'Devam etmek istiyor musunuz?',
          },
          exportFormatCSV: 'CSV için bir dışa aktarma formatı seçin',
          exportFormatPDF: 'PDF için bir dışa aktarma formatı seçin',
        },
      },
      myDashboard: {
        assignedActions: {
          index: {
            errorMessage: 'Atanan eylemleri yüklerken hata oluştu. Lütfen tekrar deneyin.',
          },
        },
        kpi: {
          title: 'Temel Performans Göstergeleri',
          filters: 'Filtreler',
          myData: 'Verilerim',
          companyData: 'Şirket Verileri',
          financialTitle: 'Maliyet Tasarrufu',
          leaksTitle: 'Olay İstatistikleri',
          energyTitle: 'Enerji Tasarrufu',
          totalIdentified: 'Toplam Tespit Edilen',
          repaired: 'Onarıldı',
          unrepaired: 'Onarılmadı',
          ofTotal: 'toplam',
          myStanding: 'Sıralamam',
          gaugeTooltipLeaks:
            'Seçilen tarih aralığında sızıntı kaydeden diğer kullanıcılarla sızıntı sayınızı karşılaştırır. Çubuk en düşükten en yüksek sayıya kadar uzanır.',
          gaugeTooltipEnergy:
            'Seçilen tarih aralığında sızıntı kaydeden diğer kullanıcılarla enerji tasarrufunuzu karşılaştırır. Çubuk en düşükten en yüksek kWh değerine kadar uzanır.',
          gaugeTooltipCost:
            'Seçilen tarih aralığında sızıntı kaydeden diğer kullanıcılarla maliyetinizi karşılaştırır. Sonuçlar para birimine göre gruplandırılır.',
          tooltipCostTotal:
            'Belirlediğiniz potansiyel maliyet tasarrufunun toplam değeri. Sıralamalar, maliyet tasarrufu belirlemiş olan şirketinizdeki tüm kullanıcıları içerir.',
          tooltipCostRepaired: 'Belirlediğiniz maliyet tasarrufunun çözülmüş kısmı.',
          tooltipCostUnrepaired: 'Belirlediğiniz maliyet tasarrufunun çözülmemiş kısmı.',
          tooltipLeaksTotal:
            'Oluşturup platforma yüklediğiniz toplam sızıntı kaydı sayısı. Sıralamalar, en az bir kayıt yüklemiş olan şirketinizdeki tüm kullanıcıları içerir.',
          tooltipLeaksRepaired: 'Kayıtlarınızın çözülmüş kısmı.',
          tooltipLeaksUnrepaired: 'Kayıtlarınızın çözülmemiş kısmı.',
          tooltipEnergyTotal:
            'Belirlediğiniz potansiyel enerji tasarrufunun toplam değeri. Sıralamalar, enerji tasarrufu belirlemiş olan şirketinizdeki tüm kullanıcıları içerir.',
          tooltipEnergyRepaired: 'Belirlediğiniz enerji tasarrufunun çözülmüş kısmı.',
          tooltipEnergyUnrepaired: 'Belirlediğiniz enerji tasarrufunun çözülmemiş kısmı.',
          gaugeLowest: 'En düşük',
          gaugeHighest: 'En yüksek',
          noData: 'Seçilen filtreler için veri bulunamadı.',
          apply: 'Uygula',
          cancel: 'İptal',
          changeDates: 'Tarihleri değiştir',
          loading: 'Yükleniyor...',
          selectDateRange: 'Bir tarih aralığı seçin',
          selectDateRangeDescription: "Bir tarih aralığı seçin ve KPI'larınızı görmek için Uygula'ya tıklayın.",
          datePresets: {
            label: 'Tarih ön ayarları',
            today: 'Bugün',
            yesterday: 'Dün',
            last7Days: 'Son 7 Gün',
            last30Days: 'Son 30 Gün',
            thisWeek: 'Bu Hafta',
            lastWeek: 'Geçen Hafta',
            thisMonth: 'Bu Ay',
            lastMonth: 'Geçen Ay',
            thisYear: 'Bu Yıl',
            lastYear: 'Geçen Yıl',
            allTime: 'Tüm zamanlar',
          },
          calendar: {
            weekDays: {
              mon: 'Pzt',
              tue: 'Sal',
              wed: 'Çar',
              thu: 'Per',
              fri: 'Cum',
              sat: 'Cmt',
              sun: 'Paz',
            },
            months: {
              january: 'Ocak',
              february: 'Şubat',
              march: 'Mart',
              april: 'Nisan',
              may: 'Mayıs',
              june: 'Haziran',
              july: 'Temmuz',
              august: 'Ağustos',
              september: 'Eylül',
              october: 'Ekim',
              november: 'Kasım',
              december: 'Aralık',
            },
          },
        },
        charts: {
          charts: {
            errorMessages: {
              errorMessageOne: 'Kaçak kayıtlarını yüklerken hata oluştu. Lütfen tekrar deneyin.',
            },
          },
        },
        index: {
          assignedActions: 'Size Atanan Eylemler',
        },
      },
      export: {
        imageUrl: "Kayıt resim URL'si {{number}}",
        additionalImageUrl: "Ek sızıntı görüntü URL'si {{number}}",
        audioFileUrlOne: 'Ses Dosyası URL',
        smartTag: 'Akıllı Etiket',
        workRef: 'İş Referansı',
        per: 'başına ',
      },
      downloadApk: {
        pageTitle: 'PROSARIS - Uygulamayı indir',
        title: 'PROSARIS Uygulamasını İndir',
        mobileInstructions:
          'Bu sayfayı bir tablet veya mobil cihazda görüntülüyorsanız, PROSARIS uygulamasını cihazınıza indirmek için aşağıdaki "İndir" düğmesine dokunun.',
        desktopInstructions:
          'Bu sayfayı bir bilgisayarda görüntülüyorsanız, tablet veya mobil cihazınızla QR kodunu tarayın ve uygulamayı oradan indirin.',
        downloadButton: 'İndir',
        qrCodeLabel: 'PROSARIS Uygulamasını İndir',
        additionalInstructions: {
          title: 'Ek indirme talimatları',
          description:
            'Bir web sitesinden APK (Android Paket Kiti) indiriyorsunuz ve Google Play üzerinden indirilen uygulamalara kıyasla ek güvenlik önlemleriyle karşılaşabilirsiniz.',
          step1: '"Bu dosya zararlı olabilir" uyarısı alabilirsiniz. "Yine de indir" seçeneğine dokunun.',
          step2:
            'Cihazınız "Bu kaynaktan bilinmeyen uygulamaların yüklenmesine izin verilmiyor" uyarısı verebilir. Cihaz ayarlarını açmanız istenecektir.',
          step3: 'Yönlendirildiğiniz Ayarlar sayfasında, bilinmeyen uygulama indirmelerine izin vermek için anahtarı açın.',
          step4:
            'Son güvenlik adımı olarak "Uygulamayı tara" isteğiyle karşılaşabilirsiniz. Taramanın ardından uygulamayı indirmeniz istenecektir.',
        },
      },
    },
    languages: {
      English: 'İngilizce',
      Chinese: 'Çince',
      Spanish: 'İspanyolca',
      French: 'Fransızca',
      German: 'Almanca',
      Norwegian: 'Norveççe',
      Italian: 'İtalyanca',
      Turkish: 'Türkçe',
      Japanese: 'Japonca',
      Portuguese: 'Portugisçe',
      Korean: 'Koreanca',
    },
  },
};
